import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: string; output: string; }
  ExpectedError: { input: any; output: any; }
  GeoJSON: { input: any; output: any; }
  JSON: { input: any; output: any; }
  UUID: { input: string; output: string; }
  Upload: { input: any; output: any; }
  image: { input: any; output: any; }
};

export type AccountResponseType = {
  __typename?: 'AccountResponseType';
  account: AccountType;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type AccountSubscriptionType = {
  __typename?: 'AccountSubscriptionType';
  id: Scalars['ID']['output'];
  isManuallySet: Scalars['Boolean']['output'];
  stripeCurrentPeriodEnd?: Maybe<Scalars['Date']['output']>;
  stripeRenewalFailed: Scalars['Boolean']['output'];
  subscriptionPlan: SubscriptionPlanType;
};

export type AccountType = {
  __typename?: 'AccountType';
  createdAt: Scalars['DateTime']['output'];
  devices: Array<DeviceType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  subscriptionPlan: SubscriptionPlanType;
};

export type AlertMessageType = {
  __typename?: 'AlertMessageType';
  ackTime?: Maybe<Scalars['DateTime']['output']>;
  eventDevice: EventDeviceType;
  id: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  sendTime: Scalars['DateTime']['output'];
  sender?: Maybe<BaseUserType>;
};

export type AllMutations = {
  __typename?: 'AllMutations';
  /**
   * Archive account and revoke refresh tokens.
   *
   *     User must be verified and confirm password.
   *
   */
  archiveAccount: MutationNormalOutput;
  /**
   * Creates a brand-new captcha. Returns a base64 encoded string of the
   *         captcha. And uuid representing the captcha id in the database. When you
   *         will try to log in or register You will need submit that uuid With the
   *         user input.
   *
   *         **The captcha will be invoked when the timeout expires**.
   *
   */
  captcha: CaptchaType;
  createDevice: DeviceResponseType;
  createEvent: PodiumEventResponseType;
  createEventDevice: EventDeviceResponseType;
  createPreset: PresetResponseType;
  createTelemetryExport: CreateTelemetryExportResponseType;
  createTelemetryImport: CreateTelemetryImportResponseType;
  createUser: UserResponseType;
  createVenue: VenueResponseType;
  createVenueSectorScheme: SectorSchemeResponseType;
  /**
   * Delete account permanently or make `user.is_active=False`.
   *
   *     The behavior is defined on settings. Anyway user refresh tokens are
   *     revoked.
   *
   *     User must be verified and confirm password.
   *
   */
  deleteAccount: MutationNormalOutput;
  deleteDevice: OkResponseType;
  deleteEvent: ResponseType;
  deleteEventDevice: OkResponseType;
  deletePreset: OkResponseType;
  deleteTelemetryExport: ResponseType;
  deleteTelemetryImport: ResponseType;
  deleteVenue: ResponseType;
  deleteVenueSectorScheme: ResponseType;
  followUser: ResponseType;
  generateSourceFileDownloadLink: GenerateSourceFileDownloadLinkResponseType;
  generateTelemetryExportFileDownloadLink: GenerateTelemetryExportFileDownloadLinkResponseType;
  /**
   * Change account password when user knows the old password.
   *
   *     A new token and refresh token are sent. User must be verified.
   *
   */
  passwordChange: ObtainJsonWebTokenType;
  /**
   * Change user password without old password.
   *
   *     Receive the token that was sent by email.
   *
   *     If token and new passwords are valid, update user password and in
   *     case of using refresh tokens, revoke all of them.
   *
   *     Also, if user has not been verified yet, verify it.
   *
   */
  passwordReset: MutationNormalOutput;
  /**
   *
   *     Set user password - for password-less registration
   *
   *     Receive the token that was sent by email.
   *
   *     If token and new passwords are valid, set
   *     user password and in case of using refresh
   *     tokens, revoke all of them.
   *
   *     Also, if user has not been verified yet, verify it.
   *
   */
  passwordSet: MutationNormalOutput;
  ratePreset: ResponseType;
  /**
   * ### refreshToken to generate a new login token:
   *
   *     *Use this only if `JWT_LONG_RUNNING_REFRESH_TOKEN` is True*
   *
   *     using the refresh-token you already got during authorization, and
   *     obtain a brand-new token (and possibly a new refresh token if you
   *     revoked the previous). This is an alternative to log in when your
   *     token expired.
   *
   */
  refreshToken: TokenAuthResponseType;
  regenerateVenueSectorScheme: SectorSchemeResponseType;
  /**
   * Register user with fields defined in the settings. If the email field of
   *     the user model is part of the registration fields (default), check if there
   *     is no user with that email.
   *
   *     If it exists, it does not register the user, even if the email field
   *     is not defined as unique (default of the default django user model).
   *
   *     When creating the user, it also creates a `UserStatus` related to
   *     that user, making it possible to track if the user is archived /
   *     verified.
   *
   *     Send account verification email.
   *
   *     If allowed to not verified users login, return token.
   *
   */
  register: MutationNormalOutput;
  /**
   * Register user with fields defined in the settings. If the email field of
   *     the user model is part of the registration fields (default), check if there
   *     is no user with that email.
   *
   *     If it exists, it does not register the user, even if the email field
   *     is not defined as unique (default of the default django user model).
   *
   *     When creating the user, it also creates a `UserStatus` related to
   *     that user, making it possible to track if the user is archived /
   *     verified.
   *
   *     Send account verification email.
   *
   *     If allowed to not verified users login, return token.
   *
   */
  registerWithAccount: MutationNormalOutput;
  reportPreset: ResponseType;
  /**
   * Sends activation email.
   *
   *     It is called resend because theoretically the first activation email
   *     was sent when the user registered.
   *
   *     If there is no user with the requested email, a successful response
   *     is returned.
   *
   */
  resendActivationEmail: MutationNormalOutput;
  /**
   * ### Suspends a refresh token.
   *
   *     *token must exist to be revoked.*
   *
   */
  revokeToken: RevokeRefreshTokenType;
  /**
   * Send password reset email.
   *
   *     For non verified users, send an activation email instead.
   *
   *     If there is no user with the requested email, a successful response
   *     is returned.
   *
   */
  sendPasswordResetEmail: MutationNormalOutput;
  setPrimarySectorScheme: SectorSchemeResponseType;
  subscriptionManagmentSessionUrl: StripeSessionResponseType;
  superuserCreateAccount: SuperuserAccountResponseType;
  superuserCreatePreset: SuperuserPresetResponseType;
  superuserCreatePresetType: SuperuserPresetTypeResponseType;
  superuserCreateUser: SuperuserUserResponseType;
  superuserDeactivateUser: SuperuserUserResponseType;
  superuserDeleteAccount: OkResponseType;
  superuserDeleteEvent: OkResponseType;
  superuserDeleteEventDevice: OkResponseType;
  superuserDeletePreset: OkResponseType;
  superuserDeletePresetType: ResponseType;
  superuserDeleteTelemetryExport: OkResponseType;
  superuserDeleteTelemetryImport: OkResponseType;
  superuserDeleteUser: OkResponseType;
  superuserDowngradeUser: OkResponseType;
  superuserElevateUser: OkResponseType;
  superuserExportPublicVenueLeaderboards: PublicVenueLeaderboardExportResultType;
  superuserGenerateTelemetryExportDownloadLink: GenerateTelemetryExportDownloadLinkResponseType;
  superuserGenerateTelemetryImportDownloadLink: GenerateTelemetryImportDownloadLinkResponseType;
  superuserGetEventDeviceDataSegmentDownloadLink: SuperuserEventDeviceDataSegmentDownloadLinkResponseType;
  superuserReactivateUser: SuperuserUserResponseType;
  superuserRegenerateVenueGeometry: VenueGeometryRegenResponseType;
  superuserRetryTelemetryImport: OkResponseType;
  superuserUpdateAccount: SuperuserAccountResponseType;
  superuserUpdateAccountSubscription: SuperuserAccountSubscriptionResponseType;
  superuserUpdatePreset: SuperuserPresetResponseType;
  superuserUpdatePresetType: SuperuserPresetTypeResponseType;
  superuserUpdateUser: SuperuserUserResponseType;
  /**
   * Obtain JSON web token for given user.
   *
   *     Allow to perform login with different fields, The fields are defined
   *     on settings.
   *
   *     Not verified users can log in by default. This can be changes on
   *     settings.
   *
   *     If user is archived, make it unarchived and return
   *     `unarchiving=True` on OutputBase.
   *
   */
  tokenAuth: TokenAuthResponseType;
  unfollowUser: ResponseType;
  updateAccount: AccountResponseType;
  updateDevice: DeviceResponseType;
  updateEvent: PodiumEventResponseType;
  updateEventDevice: EventDeviceResponseType;
  updatePreset: PresetResponseType;
  updateUser: UserResponseType;
  updateUserMe: UserResponseType;
  updateVenue: VenueResponseType;
  updateVenueSectorScheme: SectorSchemeResponseType;
  validateEventId: OkResponseType;
  validateEventdeviceId: OkResponseType;
  validateEventdeviceOwnership: OkResponseType;
  /**
   * Verify user account.
   *
   *     Receive the token that was sent by email. If the token is valid,
   *     make the user verified by making the `user.status.verified` field
   *     true.
   *
   */
  verifyAccount: MutationNormalOutput;
  /**
   * ### Checks if a token is not expired and correct.
   *
   *     *Note that this is not for refresh tokens.*
   *
   */
  verifyToken: VerifyTokenType;
};


export type AllMutationsArchiveAccountArgs = {
  password: Scalars['String']['input'];
};


export type AllMutationsCreateDeviceArgs = {
  isPrivate: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
};


export type AllMutationsCreateEventArgs = {
  endAt: Scalars['DateTime']['input'];
  isPrivate: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  startAt: Scalars['DateTime']['input'];
  venueId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllMutationsCreateEventDeviceArgs = {
  competitorNumber?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  eventId: Scalars['UUID']['input'];
};


export type AllMutationsCreatePresetArgs = {
  isPrivate?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  presetData: Scalars['String']['input'];
  presetTypeId?: InputMaybe<Scalars['UUID']['input']>;
  presetTypeKey?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  previewImageData?: InputMaybe<Scalars['String']['input']>;
  previewImageName?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsCreateTelemetryExportArgs = {
  eventDeviceId: Scalars['UUID']['input'];
};


export type AllMutationsCreateTelemetryImportArgs = {
  deviceId: Scalars['UUID']['input'];
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  fileName: Scalars['String']['input'];
};


export type AllMutationsCreateUserArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isAdmin: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type AllMutationsCreateVenueArgs = {
  configuration?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  finish?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sectorPoints?: InputMaybe<Scalars['String']['input']>;
  startFinish?: InputMaybe<Scalars['String']['input']>;
  trackMap?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsCreateVenueSectorSchemeArgs = {
  copyFrom?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  venueId: Scalars['UUID']['input'];
};


export type AllMutationsDeleteAccountArgs = {
  password: Scalars['String']['input'];
};


export type AllMutationsDeleteDeviceArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsDeleteEventArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsDeleteEventDeviceArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsDeletePresetArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsDeleteTelemetryExportArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsDeleteTelemetryImportArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsDeleteVenueArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsDeleteVenueSectorSchemeArgs = {
  key: Scalars['String']['input'];
  venueId: Scalars['UUID']['input'];
};


export type AllMutationsFollowUserArgs = {
  slug: Scalars['String']['input'];
};


export type AllMutationsGenerateSourceFileDownloadLinkArgs = {
  telemetryImportId: Scalars['UUID']['input'];
};


export type AllMutationsGenerateTelemetryExportFileDownloadLinkArgs = {
  telemetryExportId: Scalars['UUID']['input'];
};


export type AllMutationsPasswordChangeArgs = {
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type AllMutationsPasswordResetArgs = {
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type AllMutationsPasswordSetArgs = {
  newPassword1: Scalars['String']['input'];
  newPassword2: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type AllMutationsRatePresetArgs = {
  presetId: Scalars['UUID']['input'];
  rating: Scalars['Int']['input'];
  report?: InputMaybe<Scalars['Int']['input']>;
};


export type AllMutationsRefreshTokenArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  revokeRefreshToken: Scalars['Boolean']['input'];
};


export type AllMutationsRegenerateVenueSectorSchemeArgs = {
  key: Scalars['String']['input'];
  venueId: Scalars['UUID']['input'];
};


export type AllMutationsRegisterArgs = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
};


export type AllMutationsRegisterWithAccountArgs = {
  accountName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsReportPresetArgs = {
  presetId: Scalars['UUID']['input'];
  report: Scalars['Int']['input'];
};


export type AllMutationsResendActivationEmailArgs = {
  email: Scalars['String']['input'];
};


export type AllMutationsRevokeTokenArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsSendPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};


export type AllMutationsSetPrimarySectorSchemeArgs = {
  key: Scalars['String']['input'];
  venueId: Scalars['UUID']['input'];
};


export type AllMutationsSubscriptionManagmentSessionUrlArgs = {
  isMonthly?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionPlanId: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserCreateAccountArgs = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsSuperuserCreatePresetArgs = {
  isPrivate?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  presetData: Scalars['String']['input'];
  presetTypeId: Scalars['UUID']['input'];
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
};


export type AllMutationsSuperuserCreatePresetTypeArgs = {
  description: Scalars['String']['input'];
  prettyName: Scalars['String']['input'];
  typeKey: Scalars['String']['input'];
};


export type AllMutationsSuperuserCreateUserArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsSuperuserDeactivateUserArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserDeleteAccountArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserDeleteEventArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserDeleteEventDeviceArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserDeletePresetArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserDeletePresetTypeArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserDeleteTelemetryExportArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserDeleteTelemetryImportArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserDeleteUserArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserDowngradeUserArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserElevateUserArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserExportPublicVenueLeaderboardsArgs = {
  force?: Scalars['Boolean']['input'];
  skipImages?: Scalars['Boolean']['input'];
};


export type AllMutationsSuperuserGenerateTelemetryExportDownloadLinkArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserGenerateTelemetryImportDownloadLinkArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserGetEventDeviceDataSegmentDownloadLinkArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserReactivateUserArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserRegenerateVenueGeometryArgs = {
  force?: Scalars['Boolean']['input'];
  limit?: Scalars['Int']['input'];
};


export type AllMutationsSuperuserRetryTelemetryImportArgs = {
  id: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserUpdateAccountArgs = {
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsSuperuserUpdateAccountSubscriptionArgs = {
  accountId: Scalars['UUID']['input'];
  subscriptionPlanId: Scalars['UUID']['input'];
};


export type AllMutationsSuperuserUpdatePresetArgs = {
  id: Scalars['UUID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  presetData?: InputMaybe<Scalars['String']['input']>;
  presetTypeId?: InputMaybe<Scalars['UUID']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
};


export type AllMutationsSuperuserUpdatePresetTypeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  prettyName?: InputMaybe<Scalars['String']['input']>;
  typeKey?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsSuperuserUpdateUserArgs = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<Scalars['String']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['Upload']['input']>;
};


export type AllMutationsTokenAuthArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsUnfollowUserArgs = {
  slug: Scalars['String']['input'];
};


export type AllMutationsUpdateAccountArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsUpdateDeviceArgs = {
  id: Scalars['UUID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
};


export type AllMutationsUpdateEventArgs = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['UUID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  venueId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllMutationsUpdateEventDeviceArgs = {
  competitorNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};


export type AllMutationsUpdatePresetArgs = {
  id: Scalars['UUID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  presetData?: InputMaybe<Scalars['String']['input']>;
  presetTypeId?: InputMaybe<Scalars['UUID']['input']>;
  presetTypeKey?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  previewImageData?: InputMaybe<Scalars['String']['input']>;
  previewImageName?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsUpdateUserArgs = {
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<Scalars['String']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['Upload']['input']>;
};


export type AllMutationsUpdateUserMeArgs = {
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<Scalars['String']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['Upload']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsUpdateVenueArgs = {
  configuration?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  finish?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  length?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sectorPoints?: InputMaybe<Scalars['String']['input']>;
  startFinish?: InputMaybe<Scalars['String']['input']>;
  trackMap?: InputMaybe<Scalars['String']['input']>;
};


export type AllMutationsUpdateVenueSectorSchemeArgs = {
  key: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  points: Array<SectorPointInput>;
  venueId: Scalars['UUID']['input'];
};


export type AllMutationsValidateEventIdArgs = {
  eventId: Scalars['String']['input'];
};


export type AllMutationsValidateEventdeviceIdArgs = {
  eventdeviceId: Scalars['String']['input'];
};


export type AllMutationsValidateEventdeviceOwnershipArgs = {
  eventdeviceId: Scalars['String']['input'];
};


export type AllMutationsVerifyAccountArgs = {
  token: Scalars['String']['input'];
};


export type AllMutationsVerifyTokenArgs = {
  token: Scalars['String']['input'];
};

export type AllQueriesWithSuperuser = {
  __typename?: 'AllQueriesWithSuperuser';
  accountSubscription?: Maybe<AccountSubscriptionType>;
  accounts: Array<AccountType>;
  accountsByName: Array<AccountType>;
  activeEventDevices: Array<EventDeviceType>;
  alertMessages: Array<AlertMessageType>;
  deviceById: DeviceType;
  eventById: PodiumEventType;
  eventDeviceById: EventDeviceType;
  eventDeviceLapSummaries: Array<EventDeviceLapSummaryType>;
  eventDevices: Array<EventDeviceType>;
  events: PodiumEventTypePaginatedResponseType;
  features: Array<FeatureType>;
  feed: PodiumEventTypePaginatedResponseType;
  followers: Array<FriendshipType>;
  following: Array<FriendshipType>;
  isFollowing: Scalars['Boolean']['output'];
  lapById: LapType;
  laps: Array<LapType>;
  me: UserType;
  myAccount: AccountType;
  myDevices: Array<DeviceType>;
  myEvents: PodiumEventTypePaginatedResponseType;
  myPresets: Array<PresetType>;
  myVenues: VenueTypePaginatedResponseType;
  presetById: PresetType;
  presetTypeById: PresetTypeType;
  presetTypes: Array<PresetTypeType>;
  presets: Array<PresetType>;
  presetsPaginated: PresetTypePaginatedResponseType;
  /** Returns the current user if he is not anonymous. */
  publicUser?: Maybe<UserType>;
  publicUserEvents: PodiumEventTypePaginatedResponseType;
  publicUserFollowers: PublicUserTypePaginatedResponseType;
  publicUserFollowing: PublicUserTypePaginatedResponseType;
  subscriptionPlans: Array<SubscriptionPlanType>;
  superuserAccountById: AccountType;
  superuserAccounts: Array<AccountType>;
  superuserActiveEventDevices: Array<EventDeviceType>;
  superuserDeviceById: DeviceType;
  superuserDevices: DeviceTypePaginatedResponseType;
  superuserEventById: PodiumEventType;
  superuserEventDeviceById: PodiumEventDeviceType;
  superuserEventDeviceDataSegment: EventDeviceDataSegmentType;
  superuserEventDeviceDataSegments: Array<EventDeviceDataSegmentType>;
  superuserEventDevices: Array<PodiumEventDeviceType>;
  superuserEvents: PodiumEventTypePaginatedResponseType;
  superuserLap: LapType;
  superuserLaps: Array<LapType>;
  superuserPresetById: PresetType;
  superuserPresetTypeById: PresetTypeType;
  superuserPresetTypes: Array<PresetTypeType>;
  superuserPresets: PresetTypePaginatedResponseType;
  superuserPublicVenueLeaderboardExportState: PublicVenueLeaderboardExportJobStateType;
  superuserSummary: SuperuserSummaryType;
  superuserTelemetryExportById: TelemetryExportType;
  superuserTelemetryExports: TelemetryExportTypePaginatedResponseType;
  superuserTelemetryImportById: TelemetryImportType;
  superuserTelemetryImports: TelemetryImportTypePaginatedResponseType;
  superuserUserById: BaseUserType;
  superuserUsers: BaseUserTypePaginatedResponseType;
  superuserUsersByAccountId: Array<BaseUserType>;
  superuserVenueGeometryStatus: VenueGeometryStatusType;
  telemetryExports: Array<TelemetryExportType>;
  telemetryImportById: TelemetryImportType;
  telemetryImports: TelemetryImportTypePaginatedResponseType;
  user: BaseUserType;
  userById: BaseUserType;
  userBySlug: PublicUserType;
  userMe: BaseUserType;
  users: Array<BaseUserType>;
  venueById: VenueType;
  venues: VenueTypePaginatedResponseType;
  venuesByName: Array<VenueType>;
};


export type AllQueriesWithSuperuserAccountsByNameArgs = {
  nameSearch: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserAlertMessagesArgs = {
  eventDeviceId: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserDeviceByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserEventByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserEventDeviceByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserEventDeviceLapSummariesArgs = {
  eventId: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserEventDevicesArgs = {
  eventId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserEventsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  timeFilter?: InputMaybe<EventTimeFilter>;
  venueId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserFeedArgs = {
  location?: InputMaybe<LocationInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserIsFollowingArgs = {
  slug: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserLapByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserLapsArgs = {
  eventDeviceId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserMyEventsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  timeFilter?: InputMaybe<EventTimeFilter>;
  venueId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserMyPresetsArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  presetTypeKey?: InputMaybe<Scalars['String']['input']>;
  publicOnly?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserMyVenuesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserPresetByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserPresetTypeByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserPresetsArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  mine?: Scalars['Boolean']['input'];
  presetTypeKey?: InputMaybe<Scalars['String']['input']>;
  publicOnly?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserPresetsPaginatedArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  mine?: Scalars['Boolean']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  presetTypeKey?: InputMaybe<Scalars['String']['input']>;
  publicOnly?: Scalars['Boolean']['input'];
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserPublicUserEventsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserPublicUserFollowersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserPublicUserFollowingArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserSuperuserAccountByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserDeviceByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserDevicesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserSuperuserEventByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserEventDeviceByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserEventDeviceDataSegmentArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserEventDeviceDataSegmentsArgs = {
  eventDeviceId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserSuperuserEventDevicesArgs = {
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserSuperuserEventsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserSuperuserLapArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserLapsArgs = {
  eventDeviceId: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserPresetByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserPresetTypeByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserPresetsArgs = {
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserSuperuserTelemetryExportByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserTelemetryExportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserSuperuserTelemetryImportByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserTelemetryImportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type AllQueriesWithSuperuserSuperuserUserByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserSuperuserUsersArgs = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserSuperuserUsersByAccountIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserTelemetryExportsArgs = {
  eventDeviceId?: InputMaybe<Scalars['UUID']['input']>;
};


export type AllQueriesWithSuperuserTelemetryImportByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserTelemetryImportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserUserArgs = {
  email: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserUserByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserUserBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type AllQueriesWithSuperuserVenueByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type AllQueriesWithSuperuserVenuesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Array<LocationInputType>>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type AllQueriesWithSuperuserVenuesByNameArgs = {
  name: Scalars['String']['input'];
};

export type BaseUserType = {
  __typename?: 'BaseUserType';
  account: AccountType;
  avatarLarge?: Maybe<Scalars['String']['output']>;
  avatarMedium?: Maybe<Scalars['String']['output']>;
  avatarSmall?: Maybe<Scalars['String']['output']>;
  bio: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  devices: Array<DeviceType>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  links: Array<Scalars['String']['output']>;
  profilePictureLarge?: Maybe<Scalars['String']['output']>;
  profilePictureMedium?: Maybe<Scalars['String']['output']>;
  profilePictureSmall?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type BaseUserTypePaginatedResponseType = {
  __typename?: 'BaseUserTypePaginatedResponseType';
  items: Array<BaseUserType>;
  metadata: PaginationMetadata;
};

export type CaptchaType = {
  __typename?: 'CaptchaType';
  image: DjangoImageType;
  /** returns the b64 encoded image. */
  pilImage: Scalars['image']['output'];
  uuid: Scalars['UUID']['output'];
};

export type CreateTelemetryExportResponseType = {
  __typename?: 'CreateTelemetryExportResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  telemetryExport?: Maybe<TelemetryExportType>;
};

export type CreateTelemetryImportResponseType = {
  __typename?: 'CreateTelemetryImportResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  presignedUrl?: Maybe<Scalars['String']['output']>;
  telemetryImport?: Maybe<TelemetryImportType>;
};

export type DeviceResponseType = {
  __typename?: 'DeviceResponseType';
  device?: Maybe<DeviceType>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type DeviceType = {
  __typename?: 'DeviceType';
  account: AccountType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUserType;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isOwner: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  previewImageLarge?: Maybe<Scalars['String']['output']>;
  previewImageMedium?: Maybe<Scalars['String']['output']>;
  previewImageSmall?: Maybe<Scalars['String']['output']>;
  streamingKey: Scalars['String']['output'];
};

export type DeviceTypePaginatedResponseType = {
  __typename?: 'DeviceTypePaginatedResponseType';
  items: Array<DeviceType>;
  metadata: PaginationMetadata;
};

export type DjangoImageType = {
  __typename?: 'DjangoImageType';
  height: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type DjangoModelType = {
  __typename?: 'DjangoModelType';
  pk: Scalars['ID']['output'];
};

export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type EventDeviceDataSegmentType = {
  __typename?: 'EventDeviceDataSegmentType';
  end: Scalars['DateTime']['output'];
  eventDevice: EventDeviceType;
  filePath: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  start: Scalars['DateTime']['output'];
};

export type EventDeviceLapSummaryType = {
  __typename?: 'EventDeviceLapSummaryType';
  bestLapTime?: Maybe<Scalars['Float']['output']>;
  eventDeviceId: Scalars['UUID']['output'];
  lapCount: Scalars['Int']['output'];
  lastLapTime?: Maybe<Scalars['Float']['output']>;
};

export type EventDeviceResponseType = {
  __typename?: 'EventDeviceResponseType';
  errors: Array<ErrorType>;
  eventDevice?: Maybe<EventDeviceType>;
  ok: Scalars['Boolean']['output'];
};

export type EventDeviceType = {
  __typename?: 'EventDeviceType';
  competitorNumber: Scalars['String']['output'];
  device: DeviceType;
  deviceSn: Scalars['String']['output'];
  endTime: Scalars['DateTime']['output'];
  event: EventType;
  id: Scalars['UUID']['output'];
  metadata: Scalars['JSON']['output'];
  processorInstanceHost: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceVer: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
};

export enum EventTimeFilter {
  All = 'ALL',
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type EventType = {
  __typename?: 'EventType';
  account: AccountType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUserType;
  endAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isOwner: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  startAt: Scalars['DateTime']['output'];
  timeRangeAutoAdjustable: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FeatureType = {
  __typename?: 'FeatureType';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type FriendshipType = {
  __typename?: 'FriendshipType';
  createdAt: Scalars['DateTime']['output'];
  followed: PublicUserType;
  follower: PublicUserType;
};

export type GenerateSourceFileDownloadLinkResponseType = {
  __typename?: 'GenerateSourceFileDownloadLinkResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

export type GenerateTelemetryExportDownloadLinkResponseType = {
  __typename?: 'GenerateTelemetryExportDownloadLinkResponseType';
  downloadLink?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type GenerateTelemetryExportFileDownloadLinkResponseType = {
  __typename?: 'GenerateTelemetryExportFileDownloadLinkResponseType';
  downloadLink?: Maybe<Scalars['String']['output']>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type GenerateTelemetryImportDownloadLinkResponseType = {
  __typename?: 'GenerateTelemetryImportDownloadLinkResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

export type LapType = {
  __typename?: 'LapType';
  aggregates: Scalars['JSON']['output'];
  endTime: Scalars['DateTime']['output'];
  eventDevice: EventDeviceType;
  id: Scalars['UUID']['output'];
  lapData: Scalars['String']['output'];
  lapNumber: Scalars['Int']['output'];
  lapTime?: Maybe<Scalars['Float']['output']>;
  startTime: Scalars['DateTime']['output'];
  venue?: Maybe<VenueType>;
};


export type LapTypeLapDataArgs = {
  channels?: Array<Scalars['String']['input']>;
};

export type LocationInputType = {
  lat: Scalars['Float']['input'];
  long: Scalars['Float']['input'];
};

export type MutationNormalOutput = {
  __typename?: 'MutationNormalOutput';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  success: Scalars['Boolean']['output'];
};

/**
 *
 *     encapsulates token data, and refresh token data if `JWT_LONG_RUNNING_REFRESH_TOKEN` is on.
 *     with an output interface.
 *
 */
export type ObtainJsonWebTokenType = OutputInterface & {
  __typename?: 'ObtainJSONWebTokenType';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  refreshToken?: Maybe<RefreshTokenType>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<TokenType>;
  user?: Maybe<UserType>;
};

export type OkResponseType = {
  __typename?: 'OkResponseType';
  ok: Scalars['Boolean']['output'];
};

export type OutputInterface = {
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PaginationMetadata = {
  __typename?: 'PaginationMetadata';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PodiumEventDeviceType = {
  __typename?: 'PodiumEventDeviceType';
  competitorNumber: Scalars['String']['output'];
  device: DeviceType;
  deviceSn: Scalars['String']['output'];
  endTime: Scalars['DateTime']['output'];
  event: PodiumEventType;
  id: Scalars['UUID']['output'];
  metadata: Scalars['JSON']['output'];
  processorInstanceHost: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceVer: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type PodiumEventResponseType = {
  __typename?: 'PodiumEventResponseType';
  errors: Array<ErrorType>;
  event?: Maybe<PodiumEventType>;
  ok: Scalars['Boolean']['output'];
};

export type PodiumEventType = {
  __typename?: 'PodiumEventType';
  account: AccountType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUserType;
  endAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isOwner: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  startAt: Scalars['DateTime']['output'];
  timeRangeAutoAdjustable: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  venue?: Maybe<VenueType>;
};

export type PodiumEventTypePaginatedResponseType = {
  __typename?: 'PodiumEventTypePaginatedResponseType';
  items: Array<PodiumEventType>;
  metadata: PaginationMetadata;
};

export type PresetResponseType = {
  __typename?: 'PresetResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  preset?: Maybe<PresetType>;
};

export type PresetType = {
  __typename?: 'PresetType';
  account: AccountType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUserType;
  id: Scalars['UUID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  presetData?: Maybe<Scalars['JSON']['output']>;
  presetType: PresetTypeType;
  previewImageLarge?: Maybe<Scalars['String']['output']>;
  previewImageMedium?: Maybe<Scalars['String']['output']>;
  previewImageSmall?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  ratingCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PresetTypePaginatedResponseType = {
  __typename?: 'PresetTypePaginatedResponseType';
  items: Array<PresetType>;
  metadata: PaginationMetadata;
};

export type PresetTypeType = {
  __typename?: 'PresetTypeType';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  prettyName: Scalars['String']['output'];
  typeKey: Scalars['String']['output'];
};

export type PublicUserType = {
  __typename?: 'PublicUserType';
  avatarLarge?: Maybe<Scalars['String']['output']>;
  avatarMedium?: Maybe<Scalars['String']['output']>;
  avatarSmall?: Maybe<Scalars['String']['output']>;
  bio: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  followersCount: Scalars['Int']['output'];
  followingCount: Scalars['Int']['output'];
  followsViewer: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isFollowing: Scalars['Boolean']['output'];
  isViewer: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  links: Array<Scalars['String']['output']>;
  profilePictureLarge?: Maybe<Scalars['String']['output']>;
  profilePictureMedium?: Maybe<Scalars['String']['output']>;
  profilePictureSmall?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type PublicUserTypePaginatedResponseType = {
  __typename?: 'PublicUserTypePaginatedResponseType';
  items: Array<PublicUserType>;
  metadata: PaginationMetadata;
};

export type PublicVenueLeaderboardExportJobStateType = {
  __typename?: 'PublicVenueLeaderboardExportJobStateType';
  lastCompletedAt?: Maybe<Scalars['String']['output']>;
  lastError: Scalars['String']['output'];
  lastStartedAt?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PublicVenueLeaderboardExportResultType = {
  __typename?: 'PublicVenueLeaderboardExportResultType';
  artifacts: Array<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['String']['output']>;
  imagesPublished: Scalars['Int']['output'];
  leaderboardEntriesExported: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  venuesExported: Scalars['Int']['output'];
};

/**
 *
 * Refresh token can be used to obtain a new token instead of log in again
 * when the token expires.
 *
 * *This is only used if `JWT_LONG_RUNNING_REFRESH_TOKEN` is set to True.*
 *
 */
export type RefreshTokenType = {
  __typename?: 'RefreshTokenType';
  created: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  isExpired: Scalars['Boolean']['output'];
  revoked?: Maybe<Scalars['DateTime']['output']>;
  /** randomly generated token that is attached to a FK user. */
  token: Scalars['String']['output'];
};

export type ResponseType = {
  __typename?: 'ResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type RevokeRefreshTokenType = {
  __typename?: 'RevokeRefreshTokenType';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  refreshToken?: Maybe<RefreshTokenType>;
  success: Scalars['Boolean']['output'];
};

export type SectorPointInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type SectorPointType = {
  __typename?: 'SectorPointType';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
  s?: Maybe<Scalars['Float']['output']>;
};

export type SectorSchemeResponseType = {
  __typename?: 'SectorSchemeResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  scheme?: Maybe<SectorSchemeType>;
};

export type SectorSchemeType = {
  __typename?: 'SectorSchemeType';
  algorithmVersion?: Maybe<Scalars['Int']['output']>;
  generated: Scalars['Boolean']['output'];
  geometryVersion?: Maybe<Scalars['Int']['output']>;
  humanModified: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  points: Array<SectorPointType>;
};

export type StripeSessionResponseType = {
  __typename?: 'StripeSessionResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  stripeSessionUrl: Scalars['String']['output'];
};

export type SubscriptionPlanType = {
  __typename?: 'SubscriptionPlanType';
  features: Array<FeatureType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  prettyName: Scalars['String']['output'];
  priceMonth: Scalars['Float']['output'];
  priceYear: Scalars['Float']['output'];
};

export type SuperuserAccountResponseType = {
  __typename?: 'SuperuserAccountResponseType';
  account: AccountType;
  ok: Scalars['Boolean']['output'];
};

export type SuperuserAccountSubscriptionResponseType = {
  __typename?: 'SuperuserAccountSubscriptionResponseType';
  accountSubscription?: Maybe<AccountSubscriptionType>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
};

export type SuperuserEventDeviceDataSegmentDownloadLinkResponseType = {
  __typename?: 'SuperuserEventDeviceDataSegmentDownloadLinkResponseType';
  downloadLink?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type SuperuserPresetResponseType = {
  __typename?: 'SuperuserPresetResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  preset?: Maybe<PresetType>;
};

export type SuperuserPresetTypeResponseType = {
  __typename?: 'SuperuserPresetTypeResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  presetType?: Maybe<PresetTypeType>;
};

export type SuperuserSummaryType = {
  __typename?: 'SuperuserSummaryType';
  devicesCount: Scalars['Int']['output'];
  eventsCount: Scalars['Int']['output'];
  lapsCount: Scalars['Int']['output'];
  usersCount: Scalars['Int']['output'];
};

export type SuperuserUserResponseType = {
  __typename?: 'SuperuserUserResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  user?: Maybe<BaseUserType>;
};

export type TelemetryExportType = {
  __typename?: 'TelemetryExportType';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<BaseUserType>;
  eventDevice: EventDeviceType;
  fileType: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  s3FileKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusDisplay: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TelemetryExportTypePaginatedResponseType = {
  __typename?: 'TelemetryExportTypePaginatedResponseType';
  items: Array<TelemetryExportType>;
  metadata: PaginationMetadata;
};

export type TelemetryImportType = {
  __typename?: 'TelemetryImportType';
  createdAt: Scalars['DateTime']['output'];
  createdBy: BaseUserType;
  eventDevice: EventDeviceType;
  fileType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  s3FileKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusDisplay: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TelemetryImportTypePaginatedResponseType = {
  __typename?: 'TelemetryImportTypePaginatedResponseType';
  items: Array<TelemetryImportType>;
  metadata: PaginationMetadata;
};

/**
 *
 *     Encapsulates token data and returns the authenticated user with the
 *     application-specific GraphQL user type.
 *
 */
export type TokenAuthResponseType = {
  __typename?: 'TokenAuthResponseType';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  refreshToken?: Maybe<RefreshTokenType>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<TokenType>;
  user?: Maybe<BaseUserType>;
};

/**
 *
 * the data that was used to create the token.
 *
 */
export type TokenPayloadType = {
  __typename?: 'TokenPayloadType';
  email: Scalars['String']['output'];
  /** when the token will be expired */
  exp: Scalars['DateTime']['output'];
  /** when the token was created */
  origIat: Scalars['DateTime']['output'];
};

/**
 *
 * encapsulates the token with the payload that was used to create the token.
 *
 */
export type TokenType = {
  __typename?: 'TokenType';
  payload: TokenPayloadType;
  /** The encoded payload, namely a token. */
  token: Scalars['String']['output'];
};

export type UserResponseType = {
  __typename?: 'UserResponseType';
  user: BaseUserType;
};

export type UserStatusType = {
  __typename?: 'UserStatusType';
  archived: Scalars['Boolean']['output'];
  verified: Scalars['Boolean']['output'];
};

export type UserType = {
  __typename?: 'UserType';
  archived: Scalars['Boolean']['output'];
  dateJoined: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  logentrySet: Array<DjangoModelType>;
  status: UserStatusType;
  verified: Scalars['Boolean']['output'];
};

export type VenueGeometryRegenResponseType = {
  __typename?: 'VenueGeometryRegenResponseType';
  processed: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  results: Array<VenueGeometryRegenResultType>;
};

export type VenueGeometryRegenResultType = {
  __typename?: 'VenueGeometryRegenResultType';
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  venueId: Scalars['UUID']['output'];
};

export type VenueGeometryStatusType = {
  __typename?: 'VenueGeometryStatusType';
  stale: Scalars['Int']['output'];
  totalWithTrackMap: Scalars['Int']['output'];
};

export type VenueResponseType = {
  __typename?: 'VenueResponseType';
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  venue?: Maybe<VenueType>;
};

export type VenueType = {
  __typename?: 'VenueType';
  configuration?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  finish?: Maybe<Scalars['GeoJSON']['output']>;
  geometryAlgorithm?: Maybe<Scalars['String']['output']>;
  geometryGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  geometryStale: Scalars['Boolean']['output'];
  geometryVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['GeoJSON']['output']>;
  minLapTime?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  primarySectorScheme?: Maybe<Scalars['String']['output']>;
  sectorPoints?: Maybe<Scalars['GeoJSON']['output']>;
  sectorSchemes: Array<SectorSchemeType>;
  startFinish?: Maybe<Scalars['GeoJSON']['output']>;
  trackMap?: Maybe<Scalars['GeoJSON']['output']>;
  trackMapThumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type VenueTypePaginatedResponseType = {
  __typename?: 'VenueTypePaginatedResponseType';
  items: Array<VenueType>;
  metadata: PaginationMetadata;
};

export type VerifyTokenType = OutputInterface & {
  __typename?: 'VerifyTokenType';
  errors?: Maybe<Scalars['ExpectedError']['output']>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<TokenType>;
  user?: Maybe<UserType>;
};

export type MyAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAccountQuery = { __typename?: 'AllQueriesWithSuperuser', myAccount: { __typename?: 'AccountType', name: string, notes: string, subscriptionPlan: { __typename?: 'SubscriptionPlanType', prettyName: string } } };

export type UpdateAccountMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAccountMutation = { __typename?: 'AllMutations', updateAccount: { __typename?: 'AccountResponseType', ok: boolean } };

export type ResendActivationEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendActivationEmailMutation = { __typename?: 'AllMutations', resendActivationEmail: { __typename?: 'MutationNormalOutput', success: boolean, errors?: any | null } };

export type AccountQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AccountQuery = { __typename?: 'AllQueriesWithSuperuser', superuserAccountById: { __typename?: 'AccountType', id: string, name: string, notes: string, subscriptionPlan: { __typename?: 'SubscriptionPlanType', prettyName: string }, devices: Array<{ __typename?: 'DeviceType', id: string, name: string, createdAt: string }> } };

export type AlertMessagesQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type AlertMessagesQuery = { __typename?: 'AllQueriesWithSuperuser', alertMessages: Array<{ __typename?: 'AlertMessageType', id: string, message: string, sendTime: string, ackTime?: string | null, sender?: { __typename?: 'BaseUserType', firstName: string, lastName: string } | null }> };

export type MyDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDevicesQuery = { __typename?: 'AllQueriesWithSuperuser', myDevices: Array<{ __typename?: 'DeviceType', id: string, name: string, createdAt: string, isPrivate: boolean, streamingKey: string, previewImageSmall?: string | null, previewImageMedium?: string | null, previewImageLarge?: string | null }> };

export type DeviceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeviceQuery = { __typename?: 'AllQueriesWithSuperuser', deviceById: { __typename?: 'DeviceType', id: string, name: string, notes: string, streamingKey: string, isPrivate: boolean, previewImageSmall?: string | null, previewImageMedium?: string | null, previewImageLarge?: string | null, createdAt: string } };

export type CreateDeviceMutationVariables = Exact<{
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  isPrivate: Scalars['Boolean']['input'];
}>;


export type CreateDeviceMutation = { __typename?: 'AllMutations', createDevice: { __typename?: 'DeviceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeleteDeviceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteDeviceMutation = { __typename?: 'AllMutations', deleteDevice: { __typename?: 'OkResponseType', ok: boolean } };

export type EditDeviceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditDeviceMutation = { __typename?: 'AllMutations', updateDevice: { __typename?: 'DeviceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type SuperuserDevicesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperuserDevicesQuery = { __typename?: 'AllQueriesWithSuperuser', superuserDevices: { __typename?: 'DeviceTypePaginatedResponseType', items: Array<{ __typename?: 'DeviceType', id: string, name: string, streamingKey: string, createdAt: string, createdBy: { __typename?: 'BaseUserType', id: string, email: string } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number } } };

export type SuperuserDeviceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeviceQuery = { __typename?: 'AllQueriesWithSuperuser', superuserDeviceById: { __typename?: 'DeviceType', id: string, name: string, notes: string, streamingKey: string, previewImageSmall?: string | null, previewImageMedium?: string | null, previewImageLarge?: string | null, createdAt: string, isPrivate: boolean, createdBy: { __typename?: 'BaseUserType', id: string, email: string } } };

export type EventDevicesQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
}>;


export type EventDevicesQuery = { __typename?: 'AllQueriesWithSuperuser', eventDevices: Array<{ __typename?: 'EventDeviceType', id: string, startTime: string, endTime: string, competitorNumber: string, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, isOwner: boolean, previewImageSmall?: string | null, previewImageMedium?: string | null, createdBy: { __typename?: 'BaseUserType', id: string, slug: string, firstName: string, lastName: string, avatarSmall?: string | null } } }> };

export type EventDeviceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type EventDeviceQuery = { __typename?: 'AllQueriesWithSuperuser', eventDeviceById: { __typename?: 'EventDeviceType', id: string, startTime: string, endTime: string, metadata: any, processorInstanceHost: string, device: { __typename?: 'DeviceType', id: string, name: string, streamingKey: string, isPrivate: boolean, isOwner: boolean }, event: { __typename?: 'EventType', id: string, name: string, isOwner: boolean } } };

export type SuperuserDeviceEventsQueryVariables = Exact<{
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SuperuserDeviceEventsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventDevices: Array<{ __typename?: 'PodiumEventDeviceType', id: string, event: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, venue?: { __typename?: 'VenueType', id: string, name: string } | null } }> };

export type SuperuserEventDevicesQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SuperuserEventDevicesQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventDevices: Array<{ __typename?: 'PodiumEventDeviceType', id: string, device: { __typename?: 'DeviceType', id: string, name: string, streamingKey: string, createdAt: string, createdBy: { __typename?: 'BaseUserType', id: string, email: string } } }> };

export type SuperuserEventDeviceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserEventDeviceQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventDeviceById: { __typename?: 'PodiumEventDeviceType', id: string, startTime: string, endTime: string, metadata: any, source: string, sourceVer: string, deviceSn: string, event: { __typename?: 'PodiumEventType', id: string, name: string }, device: { __typename?: 'DeviceType', id: string, name: string, isPrivate: boolean } } };

export type SuperuserLiveStreamsQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperuserLiveStreamsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserLiveStreams: Array<{ __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', id: string, name: string }, device: { __typename?: 'DeviceType', id: string, name: string, previewImageSmall?: string | null, previewImageMedium?: string | null } }> };

export type SuperuserDeleteEventDeviceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeleteEventDeviceMutation = { __typename?: 'AllMutations', superuserDeleteEventDevice: { __typename?: 'OkResponseType', ok: boolean } };

export type CreateEventDeviceMutationVariables = Exact<{
  eventId: Scalars['UUID']['input'];
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  competitorNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateEventDeviceMutation = { __typename?: 'AllMutations', createEventDevice: { __typename?: 'EventDeviceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type UpdateEventDeviceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  competitorNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEventDeviceMutation = { __typename?: 'AllMutations', updateEventDevice: { __typename?: 'EventDeviceResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeleteEventDeviceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteEventDeviceMutation = { __typename?: 'AllMutations', deleteEventDevice: { __typename?: 'OkResponseType', ok: boolean } };

export type SuperuserEventDeviceDataSegmentsQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type SuperuserEventDeviceDataSegmentsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventDeviceDataSegments: Array<{ __typename?: 'EventDeviceDataSegmentType', id: string, filePath: string, start: string, end: string }> };

export type SuperuserGetEventDeviceDataSegmentDownloadLinkMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserGetEventDeviceDataSegmentDownloadLinkMutation = { __typename?: 'AllMutations', superuserGetEventDeviceDataSegmentDownloadLink: { __typename?: 'SuperuserEventDeviceDataSegmentDownloadLinkResponseType', ok: boolean, downloadLink?: string | null } };

export type EventsQueryVariables = Exact<{
  venueId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  timeFilter?: InputMaybe<EventTimeFilter>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventsQuery = { __typename?: 'AllQueriesWithSuperuser', events: { __typename?: 'PodiumEventTypePaginatedResponseType', items: Array<{ __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isPrivate: boolean, venue?: { __typename?: 'VenueType', id: string, name: string, country: string, countryName?: string | null, length?: number | null, minLapTime?: number | null, trackMapThumbnail?: string | null } | null, createdBy: { __typename?: 'BaseUserType', id: string, slug: string, firstName: string, lastName: string, avatarSmall?: string | null, profilePictureLarge?: string | null } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type MyEventsQueryVariables = Exact<{
  venueId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  timeFilter?: InputMaybe<EventTimeFilter>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyEventsQuery = { __typename?: 'AllQueriesWithSuperuser', myEvents: { __typename?: 'PodiumEventTypePaginatedResponseType', items: Array<{ __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isPrivate: boolean, venue?: { __typename?: 'VenueType', id: string, name: string, country: string, countryName?: string | null, length?: number | null, minLapTime?: number | null, trackMapThumbnail?: string | null } | null, createdBy: { __typename?: 'BaseUserType', id: string, slug: string, firstName: string, lastName: string, avatarSmall?: string | null, profilePictureLarge?: string | null } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type PublicUserEventsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PublicUserEventsQuery = { __typename?: 'AllQueriesWithSuperuser', publicUserEvents: { __typename?: 'PodiumEventTypePaginatedResponseType', items: Array<{ __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isPrivate: boolean, createdBy: { __typename?: 'BaseUserType', id: string, slug: string, firstName: string, lastName: string, avatarSmall?: string | null }, venue?: { __typename?: 'VenueType', id: string, name: string, trackMapThumbnail?: string | null } | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type EventQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type EventQuery = { __typename?: 'AllQueriesWithSuperuser', eventById: { __typename?: 'PodiumEventType', id: string, name: string, notes: string, startAt: string, endAt: string, isPrivate: boolean, isOwner: boolean, createdBy: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, avatarSmall?: string | null, profilePictureLarge?: string | null, account: { __typename?: 'AccountType', name: string } }, venue?: { __typename?: 'VenueType', id: string, name: string, trackMap?: any | null, startFinish?: any | null, finish?: any | null, location?: any | null, country: string, countryName?: string | null, configuration?: string | null, length?: number | null, minLapTime?: number | null } | null } };

export type EventDeviceLapSummariesQueryVariables = Exact<{
  eventId: Scalars['UUID']['input'];
}>;


export type EventDeviceLapSummariesQuery = { __typename?: 'AllQueriesWithSuperuser', eventDeviceLapSummaries: Array<{ __typename?: 'EventDeviceLapSummaryType', eventDeviceId: string, lapCount: number, bestLapTime?: number | null, lastLapTime?: number | null }> };

export type CreateEventMutationVariables = Exact<{
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  startAt: Scalars['DateTime']['input'];
  endAt: Scalars['DateTime']['input'];
  isPrivate: Scalars['Boolean']['input'];
  venueId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateEventMutation = { __typename?: 'AllMutations', createEvent: { __typename?: 'PodiumEventResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type EditEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  venueId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type EditEventMutation = { __typename?: 'AllMutations', updateEvent: { __typename?: 'PodiumEventResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteEventMutation = { __typename?: 'AllMutations', deleteEvent: { __typename?: 'ResponseType', ok: boolean } };

export type SuperuserEventsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperuserEventsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEvents: { __typename?: 'PodiumEventTypePaginatedResponseType', items: Array<{ __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, venue?: { __typename?: 'VenueType', id: string, name: string } | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number } } };

export type SuperuserEventQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserEventQuery = { __typename?: 'AllQueriesWithSuperuser', superuserEventById: { __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, isPrivate: boolean, venue?: { __typename?: 'VenueType', id: string, name: string } | null } };

export type SuperuserDeleteEventMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeleteEventMutation = { __typename?: 'AllMutations', superuserDeleteEvent: { __typename?: 'OkResponseType', ok: boolean } };

export type CreateTelemetryExportMutationVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type CreateTelemetryExportMutation = { __typename?: 'AllMutations', createTelemetryExport: { __typename?: 'CreateTelemetryExportResponseType', ok: boolean } };

export type TelemetryExportsQueryVariables = Exact<{
  eventDeviceId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type TelemetryExportsQuery = { __typename?: 'AllQueriesWithSuperuser', telemetryExports: Array<{ __typename?: 'TelemetryExportType', id: string, status: string, statusDisplay: string, createdAt: string, eventDevice: { __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', name: string }, device: { __typename?: 'DeviceType', id: string, name: string, previewImageSmall?: string | null, previewImageMedium?: string | null } }, createdBy?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string } | null }> };

export type GenerateTelemetryExportFileDownloadLinkMutationVariables = Exact<{
  telemetryExportId: Scalars['UUID']['input'];
}>;


export type GenerateTelemetryExportFileDownloadLinkMutation = { __typename?: 'AllMutations', generateTelemetryExportFileDownloadLink: { __typename?: 'GenerateTelemetryExportFileDownloadLinkResponseType', ok: boolean, downloadLink?: string | null } };

export type DeleteTelemetryExportMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteTelemetryExportMutation = { __typename?: 'AllMutations', deleteTelemetryExport: { __typename?: 'ResponseType', ok: boolean } };

export type SuperuserTelemetryExportsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperuserTelemetryExportsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserTelemetryExports: { __typename?: 'TelemetryExportTypePaginatedResponseType', items: Array<{ __typename?: 'TelemetryExportType', id: string, status: string, statusDisplay: string, createdAt: string, eventDevice: { __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', name: string }, device: { __typename?: 'DeviceType', name: string, streamingKey: string } }, createdBy?: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, email: string } | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type SuperuserGenerateTelemetryExportDownloadLinkMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserGenerateTelemetryExportDownloadLinkMutation = { __typename?: 'AllMutations', superuserGenerateTelemetryExportDownloadLink: { __typename?: 'GenerateTelemetryExportDownloadLinkResponseType', ok: boolean, downloadLink?: string | null } };

export type SuperuserDeleteTelemetryExportMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeleteTelemetryExportMutation = { __typename?: 'AllMutations', superuserDeleteTelemetryExport: { __typename?: 'OkResponseType', ok: boolean } };

export type FeedQueryVariables = Exact<{
  location?: InputMaybe<LocationInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeedQuery = { __typename?: 'AllQueriesWithSuperuser', feed: { __typename?: 'PodiumEventTypePaginatedResponseType', items: Array<{ __typename?: 'PodiumEventType', id: string, name: string, startAt: string, endAt: string, createdBy: { __typename?: 'BaseUserType', id: string, slug: string, firstName: string, lastName: string, avatarSmall?: string | null, profilePictureLarge?: string | null }, venue?: { __typename?: 'VenueType', trackMapThumbnail?: string | null, name: string, country: string, countryName?: string | null, length?: number | null, minLapTime?: number | null } | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateTelemetryImportMutationVariables = Exact<{
  deviceId: Scalars['UUID']['input'];
  fileName: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CreateTelemetryImportMutation = { __typename?: 'AllMutations', createTelemetryImport: { __typename?: 'CreateTelemetryImportResponseType', ok: boolean, presignedUrl?: string | null, telemetryImport?: { __typename?: 'TelemetryImportType', id: string } | null } };

export type TelemetryImportsQueryVariables = Exact<{
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TelemetryImportsQuery = { __typename?: 'AllQueriesWithSuperuser', telemetryImports: { __typename?: 'TelemetryImportTypePaginatedResponseType', items: Array<{ __typename?: 'TelemetryImportType', id: string, filename: string, status: string, statusDisplay: string, createdAt: string, eventDevice: { __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', name: string }, device: { __typename?: 'DeviceType', id: string, name: string, previewImageSmall?: string | null, previewImageMedium?: string | null } } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type TelemetryImportQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TelemetryImportQuery = { __typename?: 'AllQueriesWithSuperuser', telemetryImportById: { __typename?: 'TelemetryImportType', id: string, filename: string, status: string, statusDisplay: string, createdAt: string, eventDevice: { __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', name: string } } } };

export type GenerateSourceFileDownloadLinkMutationVariables = Exact<{
  telemetryImportId: Scalars['UUID']['input'];
}>;


export type GenerateSourceFileDownloadLinkMutation = { __typename?: 'AllMutations', generateSourceFileDownloadLink: { __typename?: 'GenerateSourceFileDownloadLinkResponseType', ok: boolean, presignedUrl?: string | null } };

export type DeleteTelemetryImportMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteTelemetryImportMutation = { __typename?: 'AllMutations', deleteTelemetryImport: { __typename?: 'ResponseType', ok: boolean } };

export type SuperuserTelemetryImportsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperuserTelemetryImportsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserTelemetryImports: { __typename?: 'TelemetryImportTypePaginatedResponseType', items: Array<{ __typename?: 'TelemetryImportType', id: string, status: string, statusDisplay: string, createdAt: string, eventDevice: { __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', name: string }, device: { __typename?: 'DeviceType', name: string, streamingKey: string } }, createdBy: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, email: string } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type SuperuserTelemetryImportQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserTelemetryImportQuery = { __typename?: 'AllQueriesWithSuperuser', superuserTelemetryImportById: { __typename?: 'TelemetryImportType', id: string, filename: string, s3FileKey: string, status: string, statusDisplay: string, createdAt: string, eventDevice: { __typename?: 'EventDeviceType', id: string, event: { __typename?: 'EventType', name: string } }, createdBy: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string } } };

export type SuperuserGenerateTelemetryImportDownloadLinkMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserGenerateTelemetryImportDownloadLinkMutation = { __typename?: 'AllMutations', superuserGenerateTelemetryImportDownloadLink: { __typename?: 'GenerateTelemetryImportDownloadLinkResponseType', ok: boolean, presignedUrl?: string | null } };

export type SuperuserDeleteTelemetryImportMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeleteTelemetryImportMutation = { __typename?: 'AllMutations', superuserDeleteTelemetryImport: { __typename?: 'OkResponseType', ok: boolean } };

export type SuperuserRetryTelemetryImportMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserRetryTelemetryImportMutation = { __typename?: 'AllMutations', superuserRetryTelemetryImport: { __typename?: 'OkResponseType', ok: boolean } };

export type LapsQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type LapsQuery = { __typename?: 'AllQueriesWithSuperuser', laps: Array<{ __typename?: 'LapType', id: string, lapNumber: number, lapTime?: number | null, endTime: string, aggregates: any }> };

export type LapDataQueryVariables = Exact<{
  lapId: Scalars['UUID']['input'];
}>;


export type LapDataQuery = { __typename?: 'AllQueriesWithSuperuser', lapById: { __typename?: 'LapType', lapData: string } };

export type SuperuserLapsQueryVariables = Exact<{
  eventDeviceId: Scalars['UUID']['input'];
}>;


export type SuperuserLapsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserLaps: Array<{ __typename?: 'LapType', id: string, endTime: string, lapTime?: number | null }> };

export type SuperuserLapQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserLapQuery = { __typename?: 'AllQueriesWithSuperuser', superuserLap: { __typename?: 'LapType', id: string, startTime: string, endTime: string, lapTime?: number | null, aggregates: any, venue?: { __typename?: 'VenueType', id: string, name: string } | null } };

export type SuperuserSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperuserSummaryQuery = { __typename?: 'AllQueriesWithSuperuser', superuserSummary: { __typename?: 'SuperuserSummaryType', usersCount: number, devicesCount: number, eventsCount: number, lapsCount: number } };

export type PresetTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type PresetTypesQuery = { __typename?: 'AllQueriesWithSuperuser', presetTypes: Array<{ __typename?: 'PresetTypeType', id: string, prettyName: string, description: string, typeKey: string }> };

export type SuperuserPresetTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperuserPresetTypesQuery = { __typename?: 'AllQueriesWithSuperuser', superuserPresetTypes: Array<{ __typename?: 'PresetTypeType', id: string, prettyName: string, description: string, typeKey: string }> };

export type SuperuserPresetTypeQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserPresetTypeQuery = { __typename?: 'AllQueriesWithSuperuser', superuserPresetTypeById: { __typename?: 'PresetTypeType', id: string, prettyName: string, description: string, typeKey: string } };

export type SuperuserDeletePresetTypeMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeletePresetTypeMutation = { __typename?: 'AllMutations', superuserDeletePresetType: { __typename?: 'ResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type SuperuserCreatePresetTypeMutationVariables = Exact<{
  prettyName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  typeKey: Scalars['String']['input'];
}>;


export type SuperuserCreatePresetTypeMutation = { __typename?: 'AllMutations', superuserCreatePresetType: { __typename?: 'SuperuserPresetTypeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, presetType?: { __typename?: 'PresetTypeType', id: string } | null } };

export type SuperuserUpdatePresetTypeMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  prettyName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  typeKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type SuperuserUpdatePresetTypeMutation = { __typename?: 'AllMutations', superuserUpdatePresetType: { __typename?: 'SuperuserPresetTypeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type PresetsQueryVariables = Exact<{ [key: string]: never; }>;


export type PresetsQuery = { __typename?: 'AllQueriesWithSuperuser', presets: Array<{ __typename?: 'PresetType', id: string, name: string, presetType: { __typename?: 'PresetTypeType', id: string, prettyName: string } }> };

export type PresetQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PresetQuery = { __typename?: 'AllQueriesWithSuperuser', presetById: { __typename?: 'PresetType', id: string, name: string, notes: string, createdAt: string, presetData?: any | null, previewImageSmall?: string | null, previewImageMedium?: string | null, previewImageLarge?: string | null, presetType: { __typename?: 'PresetTypeType', id: string, prettyName: string } } };

export type CreatePresetMutationVariables = Exact<{
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  presetData: Scalars['String']['input'];
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  presetTypeId: Scalars['UUID']['input'];
}>;


export type CreatePresetMutation = { __typename?: 'AllMutations', createPreset: { __typename?: 'PresetResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, preset?: { __typename?: 'PresetType', id: string } | null } };

export type EditPresetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  presetData?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  presetTypeId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type EditPresetMutation = { __typename?: 'AllMutations', updatePreset: { __typename?: 'PresetResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeletePresetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeletePresetMutation = { __typename?: 'AllMutations', deletePreset: { __typename?: 'OkResponseType', ok: boolean } };

export type SuperuserPresetsQueryVariables = Exact<{
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SuperuserPresetsQuery = { __typename?: 'AllQueriesWithSuperuser', superuserPresets: { __typename?: 'PresetTypePaginatedResponseType', items: Array<{ __typename?: 'PresetType', id: string, name: string, isSystem: boolean, presetType: { __typename?: 'PresetTypeType', id: string, prettyName: string } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number } } };

export type SuperuserPresetQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserPresetQuery = { __typename?: 'AllQueriesWithSuperuser', superuserPresetById: { __typename?: 'PresetType', id: string, name: string, notes: string, createdAt: string, presetData?: any | null, previewImageSmall?: string | null, previewImageMedium?: string | null, previewImageLarge?: string | null, presetType: { __typename?: 'PresetTypeType', id: string, prettyName: string } } };

export type SuperuserCreatePresetMutationVariables = Exact<{
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  presetData: Scalars['String']['input'];
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  presetTypeId: Scalars['UUID']['input'];
}>;


export type SuperuserCreatePresetMutation = { __typename?: 'AllMutations', superuserCreatePreset: { __typename?: 'SuperuserPresetResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, preset?: { __typename?: 'PresetType', id: string } | null } };

export type SuperuserEditPresetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  presetData?: InputMaybe<Scalars['String']['input']>;
  previewImage?: InputMaybe<Scalars['Upload']['input']>;
  presetTypeId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SuperuserEditPresetMutation = { __typename?: 'AllMutations', superuserUpdatePreset: { __typename?: 'SuperuserPresetResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type SuperuserDeletePresetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SuperuserDeletePresetMutation = { __typename?: 'AllMutations', superuserDeletePreset: { __typename?: 'OkResponseType', ok: boolean } };

export type SubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionPlansQuery = { __typename?: 'AllQueriesWithSuperuser', subscriptionPlans: Array<{ __typename?: 'SubscriptionPlanType', id: string, name: string, prettyName: string, notes: string, priceMonth: number, priceYear: number, features: Array<{ __typename?: 'FeatureType', code: string }> }> };

export type FeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturesQuery = { __typename?: 'AllQueriesWithSuperuser', features: Array<{ __typename?: 'FeatureType', code: string, description: string }> };

export type AccountSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSubscriptionQuery = { __typename?: 'AllQueriesWithSuperuser', accountSubscription?: { __typename?: 'AccountSubscriptionType', isManuallySet: boolean, stripeRenewalFailed: boolean, stripeCurrentPeriodEnd?: any | null, subscriptionPlan: { __typename?: 'SubscriptionPlanType', id: string, name: string, features: Array<{ __typename?: 'FeatureType', code: string }> } } | null };

export type SubscriptionManagmentSessionUrlMutationVariables = Exact<{
  subscriptionPlanId: Scalars['UUID']['input'];
  isMonthly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SubscriptionManagmentSessionUrlMutation = { __typename?: 'AllMutations', subscriptionManagmentSessionUrl: { __typename?: 'StripeSessionResponseType', ok: boolean, stripeSessionUrl: string } };

export type SuperuserUpdateAccountSubscriptionMutationVariables = Exact<{
  accountId: Scalars['UUID']['input'];
  subscriptionPlanId: Scalars['UUID']['input'];
}>;


export type SuperuserUpdateAccountSubscriptionMutation = { __typename?: 'AllMutations', superuserUpdateAccountSubscription: { __typename?: 'SuperuserAccountSubscriptionResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, accountSubscription?: { __typename?: 'AccountSubscriptionType', id: string, isManuallySet: boolean, stripeCurrentPeriodEnd?: any | null, subscriptionPlan: { __typename?: 'SubscriptionPlanType', id: string, name: string, prettyName: string } } | null } };

export type NavbarMeQueryVariables = Exact<{ [key: string]: never; }>;


export type NavbarMeQuery = { __typename?: 'AllQueriesWithSuperuser', userMe: { __typename?: 'BaseUserType', id: string, firstName: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'AllQueriesWithSuperuser', userMe: { __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, email: string, isActive: boolean } };

export type MyProfileMeQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileMeQuery = { __typename?: 'AllQueriesWithSuperuser', userMe: { __typename?: 'BaseUserType', id: string, email: string, slug: string, firstName: string, lastName: string, bio: string, links: Array<string>, avatarSmall?: string | null, avatarMedium?: string | null, avatarLarge?: string | null, profilePictureSmall?: string | null, profilePictureMedium?: string | null, profilePictureLarge?: string | null } };

export type SignUpMutationVariables = Exact<{
  accountName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignUpMutation = { __typename?: 'AllMutations', registerWithAccount: { __typename?: 'MutationNormalOutput', success: boolean, errors?: any | null } };

export type UpdateUserMeMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  profilePicture?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type UpdateUserMeMutation = { __typename?: 'AllMutations', updateUserMe: { __typename?: 'UserResponseType', user: { __typename?: 'BaseUserType', id: string, email: string, slug: string, firstName: string, lastName: string, bio: string, links: Array<string>, avatarSmall?: string | null, avatarMedium?: string | null, avatarLarge?: string | null, profilePictureSmall?: string | null, profilePictureMedium?: string | null, profilePictureLarge?: string | null } } };

export type UserListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserListQuery = { __typename?: 'AllQueriesWithSuperuser', superuserUsers: { __typename?: 'BaseUserTypePaginatedResponseType', items: Array<{ __typename?: 'BaseUserType', id: string, firstName: string, lastName: string, email: string, lastLogin?: string | null, createdAt: string, isSuperuser: boolean, isActive: boolean, account: { __typename?: 'AccountType', subscriptionPlan: { __typename?: 'SubscriptionPlanType', prettyName: string } } }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number } } };

export type UserQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type UserQuery = { __typename?: 'AllQueriesWithSuperuser', superuserUserById: { __typename?: 'BaseUserType', id: string, email: string, lastLogin?: string | null, createdAt: string, firstName: string, lastName: string, links: Array<string>, isActive: boolean, isSuperuser: boolean, account: { __typename?: 'AccountType', id: string, name: string, subscriptionPlan: { __typename?: 'SubscriptionPlanType', id: string, name: string, prettyName: string } }, devices: Array<{ __typename?: 'DeviceType', id: string, name: string, createdAt: string }> } };

export type UserProfileQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UserProfileQuery = { __typename?: 'AllQueriesWithSuperuser', userBySlug: { __typename?: 'PublicUserType', id: string, slug: string, firstName: string, lastName: string, bio: string, links: Array<string>, followersCount: number, followingCount: number, isFollowing: boolean, followsViewer: boolean, isViewer: boolean, createdAt: string, avatarSmall?: string | null, avatarMedium?: string | null, avatarLarge?: string | null, profilePictureSmall?: string | null, profilePictureMedium?: string | null, profilePictureLarge?: string | null } };

export type PublicUserFollowersQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PublicUserFollowersQuery = { __typename?: 'AllQueriesWithSuperuser', publicUserFollowers: { __typename?: 'PublicUserTypePaginatedResponseType', items: Array<{ __typename?: 'PublicUserType', id: string, slug: string, firstName: string, lastName: string, bio: string, followersCount: number, followingCount: number, isFollowing: boolean, followsViewer: boolean, isViewer: boolean, avatarSmall?: string | null, avatarMedium?: string | null, avatarLarge?: string | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type PublicUserFollowingQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PublicUserFollowingQuery = { __typename?: 'AllQueriesWithSuperuser', publicUserFollowing: { __typename?: 'PublicUserTypePaginatedResponseType', items: Array<{ __typename?: 'PublicUserType', id: string, slug: string, firstName: string, lastName: string, bio: string, followersCount: number, followingCount: number, isFollowing: boolean, followsViewer: boolean, isViewer: boolean, avatarSmall?: string | null, avatarMedium?: string | null, avatarLarge?: string | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type FollowUserMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type FollowUserMutation = { __typename?: 'AllMutations', followUser: { __typename?: 'ResponseType', ok: boolean } };

export type UnfollowUserMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UnfollowUserMutation = { __typename?: 'AllMutations', unfollowUser: { __typename?: 'ResponseType', ok: boolean } };

export type SendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendPasswordResetEmailMutation = { __typename?: 'AllMutations', sendPasswordResetEmail: { __typename?: 'MutationNormalOutput', success: boolean, errors?: any | null } };

export type ElevateUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ElevateUserMutation = { __typename?: 'AllMutations', superuserElevateUser: { __typename?: 'OkResponseType', ok: boolean } };

export type DowngradeUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DowngradeUserMutation = { __typename?: 'AllMutations', superuserDowngradeUser: { __typename?: 'OkResponseType', ok: boolean } };

export type DeactivateUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeactivateUserMutation = { __typename?: 'AllMutations', superuserDeactivateUser: { __typename?: 'SuperuserUserResponseType', ok: boolean } };

export type ReactivateUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReactivateUserMutation = { __typename?: 'AllMutations', superuserReactivateUser: { __typename?: 'SuperuserUserResponseType', ok: boolean } };

export type CreateUserMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password1: Scalars['String']['input'];
  password2: Scalars['String']['input'];
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateUserMutation = { __typename?: 'AllMutations', superuserCreateUser: { __typename?: 'SuperuserUserResponseType', ok: boolean, user?: { __typename?: 'BaseUserType', id: string, email: string, lastLogin?: string | null } | null, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type SuperuserUpdateUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  links?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SuperuserUpdateUserMutation = { __typename?: 'AllMutations', superuserUpdateUser: { __typename?: 'SuperuserUserResponseType', ok: boolean, user?: { __typename?: 'BaseUserType', id: string, email: string, firstName: string, lastName: string, links: Array<string> } | null, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'AllMutations', superuserDeleteUser: { __typename?: 'OkResponseType', ok: boolean } };

export type VenuesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Array<LocationInputType> | LocationInputType>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VenuesQuery = { __typename?: 'AllQueriesWithSuperuser', venues: { __typename?: 'VenueTypePaginatedResponseType', items: Array<{ __typename?: 'VenueType', id: string, name: string, configuration?: string | null, location?: any | null, country: string, countryName?: string | null, length?: number | null, trackMapThumbnail?: string | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type VenuesByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type VenuesByNameQuery = { __typename?: 'AllQueriesWithSuperuser', venuesByName: Array<{ __typename?: 'VenueType', id: string, name: string }> };

export type MyVenuesQueryVariables = Exact<{
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyVenuesQuery = { __typename?: 'AllQueriesWithSuperuser', myVenues: { __typename?: 'VenueTypePaginatedResponseType', items: Array<{ __typename?: 'VenueType', id: string, name: string, country: string, countryName?: string | null, length?: number | null, trackMapThumbnail?: string | null }>, metadata: { __typename?: 'PaginationMetadata', totalCount: number, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type VenueQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type VenueQuery = { __typename?: 'AllQueriesWithSuperuser', venueById: { __typename?: 'VenueType', id: string, name: string, location?: any | null, country: string, countryName?: string | null, startFinish?: any | null, finish?: any | null, length?: number | null, trackMapThumbnail?: string | null, trackMap?: any | null, sectorPoints?: any | null, configuration?: string | null, minLapTime?: number | null, primarySectorScheme?: string | null, geometryVersion?: number | null, geometryAlgorithm?: string | null, geometryGeneratedAt?: string | null, geometryStale: boolean, sectorSchemes: Array<{ __typename?: 'SectorSchemeType', key: string, kind: string, label: string, generated: boolean, humanModified: boolean, algorithmVersion?: number | null, geometryVersion?: number | null, points: Array<{ __typename?: 'SectorPointType', id?: string | null, lat: number, lon: number, s?: number | null, label?: string | null }> }> } };

export type CreateVenueMutationVariables = Exact<{
  name: Scalars['String']['input'];
  location: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  startFinish?: InputMaybe<Scalars['String']['input']>;
  finish?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  trackMap?: InputMaybe<Scalars['String']['input']>;
  sectorPoints?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateVenueMutation = { __typename?: 'AllMutations', createVenue: { __typename?: 'VenueResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type EditVenueMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  location: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  startFinish?: InputMaybe<Scalars['String']['input']>;
  finish?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  trackMap?: InputMaybe<Scalars['String']['input']>;
  sectorPoints?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditVenueMutation = { __typename?: 'AllMutations', updateVenue: { __typename?: 'VenueResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type DeleteVenueMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteVenueMutation = { __typename?: 'AllMutations', deleteVenue: { __typename?: 'ResponseType', ok: boolean } };

export type VenueGeometryStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type VenueGeometryStatusQuery = { __typename?: 'AllQueriesWithSuperuser', superuserVenueGeometryStatus: { __typename?: 'VenueGeometryStatusType', totalWithTrackMap: number, stale: number } };

export type SectorSchemeFieldsFragment = { __typename?: 'SectorSchemeType', key: string, kind: string, label: string, generated: boolean, humanModified: boolean, algorithmVersion?: number | null, geometryVersion?: number | null, points: Array<{ __typename?: 'SectorPointType', id?: string | null, lat: number, lon: number, s?: number | null, label?: string | null }> };

export type UpdateVenueSectorSchemeMutationVariables = Exact<{
  venueId: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
  points: Array<SectorPointInput> | SectorPointInput;
  label?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateVenueSectorSchemeMutation = { __typename?: 'AllMutations', updateVenueSectorScheme: { __typename?: 'SectorSchemeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, scheme?: { __typename?: 'SectorSchemeType', key: string, kind: string, label: string, generated: boolean, humanModified: boolean, algorithmVersion?: number | null, geometryVersion?: number | null, points: Array<{ __typename?: 'SectorPointType', id?: string | null, lat: number, lon: number, s?: number | null, label?: string | null }> } | null } };

export type RegenerateVenueSectorSchemeMutationVariables = Exact<{
  venueId: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
}>;


export type RegenerateVenueSectorSchemeMutation = { __typename?: 'AllMutations', regenerateVenueSectorScheme: { __typename?: 'SectorSchemeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, scheme?: { __typename?: 'SectorSchemeType', key: string, kind: string, label: string, generated: boolean, humanModified: boolean, algorithmVersion?: number | null, geometryVersion?: number | null, points: Array<{ __typename?: 'SectorPointType', id?: string | null, lat: number, lon: number, s?: number | null, label?: string | null }> } | null } };

export type SetPrimarySectorSchemeMutationVariables = Exact<{
  venueId: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
}>;


export type SetPrimarySectorSchemeMutation = { __typename?: 'AllMutations', setPrimarySectorScheme: { __typename?: 'SectorSchemeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, scheme?: { __typename?: 'SectorSchemeType', key: string } | null } };

export type CreateVenueSectorSchemeMutationVariables = Exact<{
  venueId: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  copyFrom?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateVenueSectorSchemeMutation = { __typename?: 'AllMutations', createVenueSectorScheme: { __typename?: 'SectorSchemeResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }>, scheme?: { __typename?: 'SectorSchemeType', key: string, kind: string, label: string, generated: boolean, humanModified: boolean, algorithmVersion?: number | null, geometryVersion?: number | null, points: Array<{ __typename?: 'SectorPointType', id?: string | null, lat: number, lon: number, s?: number | null, label?: string | null }> } | null } };

export type DeleteVenueSectorSchemeMutationVariables = Exact<{
  venueId: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
}>;


export type DeleteVenueSectorSchemeMutation = { __typename?: 'AllMutations', deleteVenueSectorScheme: { __typename?: 'ResponseType', ok: boolean, errors: Array<{ __typename?: 'ErrorType', field: string, message: string }> } };

export type SuperuserRegenerateVenueGeometryMutationVariables = Exact<{
  limit: Scalars['Int']['input'];
  force: Scalars['Boolean']['input'];
}>;


export type SuperuserRegenerateVenueGeometryMutation = { __typename?: 'AllMutations', superuserRegenerateVenueGeometry: { __typename?: 'VenueGeometryRegenResponseType', processed: number, remaining: number, results: Array<{ __typename?: 'VenueGeometryRegenResultType', venueId: string, name: string, status: string, message?: string | null }> } };

export const SectorSchemeFieldsFragmentDoc = gql`
    fragment SectorSchemeFields on SectorSchemeType {
  key
  kind
  label
  generated
  humanModified
  algorithmVersion
  geometryVersion
  points {
    id
    lat
    lon
    s
    label
  }
}
    `;
export const MyAccountDocument = gql`
    query MyAccount {
  myAccount {
    name
    notes
    subscriptionPlan {
      prettyName
    }
  }
}
    `;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($name: String, $notes: String) {
  updateAccount(name: $name, notes: $notes) {
    ok
  }
}
    `;
export const ResendActivationEmailDocument = gql`
    mutation ResendActivationEmail($email: String!) {
  resendActivationEmail(email: $email) {
    success
    errors
  }
}
    `;
export const AccountDocument = gql`
    query Account($id: UUID!) {
  superuserAccountById(id: $id) {
    id
    name
    notes
    subscriptionPlan {
      prettyName
    }
    devices {
      id
      name
      createdAt
    }
  }
}
    `;
export const AlertMessagesDocument = gql`
    query AlertMessages($eventDeviceId: UUID!) {
  alertMessages(eventDeviceId: $eventDeviceId) {
    id
    message
    sendTime
    ackTime
    sender {
      firstName
      lastName
    }
  }
}
    `;
export const MyDevicesDocument = gql`
    query MyDevices {
  myDevices {
    id
    name
    createdAt
    isPrivate
    streamingKey
    previewImageSmall
    previewImageMedium
    previewImageLarge
  }
}
    `;
export const DeviceDocument = gql`
    query Device($id: UUID!) {
  deviceById(id: $id) {
    id
    name
    notes
    streamingKey
    isPrivate
    previewImageSmall
    previewImageMedium
    previewImageLarge
    createdAt
  }
}
    `;
export const CreateDeviceDocument = gql`
    mutation CreateDevice($name: String!, $notes: String!, $previewImage: Upload, $isPrivate: Boolean!) {
  createDevice(
    name: $name
    notes: $notes
    previewImage: $previewImage
    isPrivate: $isPrivate
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const DeleteDeviceDocument = gql`
    mutation DeleteDevice($id: UUID!) {
  deleteDevice(id: $id) {
    ok
  }
}
    `;
export const EditDeviceDocument = gql`
    mutation EditDevice($id: UUID!, $name: String, $notes: String, $previewImage: Upload, $isPrivate: Boolean) {
  updateDevice(
    id: $id
    name: $name
    notes: $notes
    previewImage: $previewImage
    isPrivate: $isPrivate
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const SuperuserDevicesDocument = gql`
    query SuperuserDevices($name: String, $rowsPerPage: Int, $page: Int) {
  superuserDevices(name: $name, rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      name
      streamingKey
      createdAt
      createdBy {
        id
        email
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;
export const SuperuserDeviceDocument = gql`
    query SuperuserDevice($id: UUID!) {
  superuserDeviceById(id: $id) {
    id
    name
    notes
    streamingKey
    previewImageSmall
    previewImageMedium
    previewImageLarge
    createdAt
    isPrivate
    createdBy {
      id
      email
    }
  }
}
    `;
export const EventDevicesDocument = gql`
    query EventDevices($eventId: UUID!) {
  eventDevices(eventId: $eventId) {
    id
    startTime
    endTime
    competitorNumber
    processorInstanceHost
    device {
      id
      name
      isOwner
      previewImageSmall
      previewImageMedium
      createdBy {
        id
        slug
        firstName
        lastName
        avatarSmall
      }
    }
  }
}
    `;
export const EventDeviceDocument = gql`
    query EventDevice($id: UUID!) {
  eventDeviceById(id: $id) {
    id
    startTime
    endTime
    device {
      id
      name
      streamingKey
      isPrivate
      isOwner
    }
    event {
      id
      name
      isOwner
    }
    metadata
    processorInstanceHost
  }
}
    `;
export const SuperuserDeviceEventsDocument = gql`
    query SuperuserDeviceEvents($deviceId: UUID) {
  superuserEventDevices(deviceId: $deviceId) {
    id
    event {
      id
      name
      startAt
      endAt
      venue {
        id
        name
      }
    }
  }
}
    `;
export const SuperuserEventDevicesDocument = gql`
    query SuperuserEventDevices($eventId: UUID) {
  superuserEventDevices(eventId: $eventId) {
    id
    device {
      id
      name
      streamingKey
      createdAt
      createdBy {
        id
        email
      }
    }
  }
}
    `;
export const SuperuserEventDeviceDocument = gql`
    query SuperuserEventDevice($id: UUID!) {
  superuserEventDeviceById(id: $id) {
    id
    startTime
    endTime
    metadata
    source
    sourceVer
    deviceSn
    event {
      id
      name
    }
    device {
      id
      name
      isPrivate
    }
  }
}
    `;
export const SuperuserLiveStreamsDocument = gql`
    query SuperuserLiveStreams {
  superuserLiveStreams: superuserActiveEventDevices {
    id
    event {
      id
      name
    }
    device {
      id
      name
      previewImageSmall
      previewImageMedium
    }
  }
}
    `;
export const SuperuserDeleteEventDeviceDocument = gql`
    mutation SuperuserDeleteEventDevice($id: UUID!) {
  superuserDeleteEventDevice(id: $id) {
    ok
  }
}
    `;
export const CreateEventDeviceDocument = gql`
    mutation CreateEventDevice($eventId: UUID!, $deviceId: UUID, $competitorNumber: String) {
  createEventDevice(
    eventId: $eventId
    deviceId: $deviceId
    competitorNumber: $competitorNumber
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const UpdateEventDeviceDocument = gql`
    mutation UpdateEventDevice($id: UUID!, $competitorNumber: String) {
  updateEventDevice(id: $id, competitorNumber: $competitorNumber) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const DeleteEventDeviceDocument = gql`
    mutation DeleteEventDevice($id: UUID!) {
  deleteEventDevice(id: $id) {
    ok
  }
}
    `;
export const SuperuserEventDeviceDataSegmentsDocument = gql`
    query SuperuserEventDeviceDataSegments($eventDeviceId: UUID!) {
  superuserEventDeviceDataSegments(eventDeviceId: $eventDeviceId) {
    id
    filePath
    start
    end
  }
}
    `;
export const SuperuserGetEventDeviceDataSegmentDownloadLinkDocument = gql`
    mutation SuperuserGetEventDeviceDataSegmentDownloadLink($id: UUID!) {
  superuserGetEventDeviceDataSegmentDownloadLink(id: $id) {
    ok
    downloadLink
  }
}
    `;
export const EventsDocument = gql`
    query Events($venueId: UUID, $search: String, $timeFilter: EventTimeFilter, $rowsPerPage: Int, $page: Int) {
  events(
    venueId: $venueId
    search: $search
    timeFilter: $timeFilter
    rowsPerPage: $rowsPerPage
    page: $page
  ) {
    items {
      id
      name
      startAt
      endAt
      isPrivate
      venue {
        id
        name
        country
        countryName
        length
        minLapTime
        trackMapThumbnail
      }
      createdBy {
        id
        slug
        firstName
        lastName
        avatarSmall
        profilePictureLarge
      }
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const MyEventsDocument = gql`
    query MyEvents($venueId: UUID, $search: String, $timeFilter: EventTimeFilter, $rowsPerPage: Int, $page: Int) {
  myEvents(
    venueId: $venueId
    search: $search
    timeFilter: $timeFilter
    rowsPerPage: $rowsPerPage
    page: $page
  ) {
    items {
      id
      name
      startAt
      endAt
      isPrivate
      venue {
        id
        name
        country
        countryName
        length
        minLapTime
        trackMapThumbnail
      }
      createdBy {
        id
        slug
        firstName
        lastName
        avatarSmall
        profilePictureLarge
      }
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const PublicUserEventsDocument = gql`
    query PublicUserEvents($slug: String!, $rowsPerPage: Int, $page: Int) {
  publicUserEvents(slug: $slug, rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      name
      startAt
      endAt
      isPrivate
      createdBy {
        id
        slug
        firstName
        lastName
        avatarSmall
      }
      venue {
        id
        name
        trackMapThumbnail
      }
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const EventDocument = gql`
    query Event($id: UUID!) {
  eventById(id: $id) {
    id
    name
    notes
    startAt
    endAt
    isPrivate
    isOwner
    createdBy {
      id
      firstName
      lastName
      avatarSmall
      profilePictureLarge
      account {
        name
      }
    }
    venue {
      id
      name
      trackMap
      startFinish
      finish
      location
      country
      countryName
      configuration
      length
      minLapTime
    }
  }
}
    `;
export const EventDeviceLapSummariesDocument = gql`
    query EventDeviceLapSummaries($eventId: UUID!) {
  eventDeviceLapSummaries(eventId: $eventId) {
    eventDeviceId
    lapCount
    bestLapTime
    lastLapTime
  }
}
    `;
export const CreateEventDocument = gql`
    mutation CreateEvent($name: String!, $notes: String!, $startAt: DateTime!, $endAt: DateTime!, $isPrivate: Boolean!, $venueId: UUID) {
  createEvent(
    name: $name
    notes: $notes
    startAt: $startAt
    endAt: $endAt
    isPrivate: $isPrivate
    venueId: $venueId
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const EditEventDocument = gql`
    mutation EditEvent($id: UUID!, $name: String, $notes: String, $startAt: DateTime, $endAt: DateTime, $isPrivate: Boolean, $venueId: UUID) {
  updateEvent(
    id: $id
    name: $name
    notes: $notes
    startAt: $startAt
    endAt: $endAt
    isPrivate: $isPrivate
    venueId: $venueId
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($id: UUID!) {
  deleteEvent(id: $id) {
    ok
  }
}
    `;
export const SuperuserEventsDocument = gql`
    query SuperuserEvents($name: String, $rowsPerPage: Int, $page: Int) {
  superuserEvents(name: $name, rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      name
      startAt
      endAt
      venue {
        id
        name
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;
export const SuperuserEventDocument = gql`
    query SuperuserEvent($id: UUID!) {
  superuserEventById(id: $id) {
    id
    name
    startAt
    endAt
    isPrivate
    venue {
      id
      name
    }
  }
}
    `;
export const SuperuserDeleteEventDocument = gql`
    mutation SuperuserDeleteEvent($id: UUID!) {
  superuserDeleteEvent(id: $id) {
    ok
  }
}
    `;
export const CreateTelemetryExportDocument = gql`
    mutation CreateTelemetryExport($eventDeviceId: UUID!) {
  createTelemetryExport(eventDeviceId: $eventDeviceId) {
    ok
  }
}
    `;
export const TelemetryExportsDocument = gql`
    query TelemetryExports($eventDeviceId: UUID) {
  telemetryExports(eventDeviceId: $eventDeviceId) {
    id
    status
    statusDisplay
    createdAt
    eventDevice {
      id
      event {
        name
      }
      device {
        id
        name
        previewImageSmall
        previewImageMedium
      }
    }
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export const GenerateTelemetryExportFileDownloadLinkDocument = gql`
    mutation GenerateTelemetryExportFileDownloadLink($telemetryExportId: UUID!) {
  generateTelemetryExportFileDownloadLink(telemetryExportId: $telemetryExportId) {
    ok
    downloadLink
  }
}
    `;
export const DeleteTelemetryExportDocument = gql`
    mutation DeleteTelemetryExport($id: UUID!) {
  deleteTelemetryExport(id: $id) {
    ok
  }
}
    `;
export const SuperuserTelemetryExportsDocument = gql`
    query SuperuserTelemetryExports($search: String, $rowsPerPage: Int, $page: Int) {
  superuserTelemetryExports(
    search: $search
    rowsPerPage: $rowsPerPage
    page: $page
  ) {
    items {
      id
      status
      statusDisplay
      createdAt
      eventDevice {
        id
        event {
          name
        }
        device {
          name
          streamingKey
        }
      }
      createdBy {
        id
        firstName
        lastName
        email
      }
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const SuperuserGenerateTelemetryExportDownloadLinkDocument = gql`
    mutation SuperuserGenerateTelemetryExportDownloadLink($id: UUID!) {
  superuserGenerateTelemetryExportDownloadLink(id: $id) {
    ok
    downloadLink
  }
}
    `;
export const SuperuserDeleteTelemetryExportDocument = gql`
    mutation SuperuserDeleteTelemetryExport($id: UUID!) {
  superuserDeleteTelemetryExport(id: $id) {
    ok
  }
}
    `;
export const FeedDocument = gql`
    query Feed($location: LocationInputType, $page: Int, $rowsPerPage: Int) {
  feed(location: $location, page: $page, rowsPerPage: $rowsPerPage) {
    items {
      id
      name
      startAt
      endAt
      createdBy {
        id
        slug
        firstName
        lastName
        avatarSmall
        profilePictureLarge
      }
      venue {
        trackMapThumbnail
        name
        country
        countryName
        length
        minLapTime
      }
    }
    metadata {
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const CreateTelemetryImportDocument = gql`
    mutation CreateTelemetryImport($deviceId: UUID!, $fileName: String!, $eventId: UUID) {
  createTelemetryImport(
    deviceId: $deviceId
    fileName: $fileName
    eventId: $eventId
  ) {
    ok
    presignedUrl
    telemetryImport {
      id
    }
  }
}
    `;
export const TelemetryImportsDocument = gql`
    query TelemetryImports($rowsPerPage: Int, $page: Int) {
  telemetryImports(rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      filename
      status
      statusDisplay
      eventDevice {
        id
        event {
          name
        }
        device {
          id
          name
          previewImageSmall
          previewImageMedium
        }
      }
      createdAt
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const TelemetryImportDocument = gql`
    query TelemetryImport($id: UUID!) {
  telemetryImportById(id: $id) {
    id
    filename
    status
    statusDisplay
    eventDevice {
      id
      event {
        name
      }
    }
    createdAt
  }
}
    `;
export const GenerateSourceFileDownloadLinkDocument = gql`
    mutation GenerateSourceFileDownloadLink($telemetryImportId: UUID!) {
  generateSourceFileDownloadLink(telemetryImportId: $telemetryImportId) {
    ok
    presignedUrl
  }
}
    `;
export const DeleteTelemetryImportDocument = gql`
    mutation DeleteTelemetryImport($id: UUID!) {
  deleteTelemetryImport(id: $id) {
    ok
  }
}
    `;
export const SuperuserTelemetryImportsDocument = gql`
    query SuperuserTelemetryImports($search: String, $rowsPerPage: Int, $page: Int) {
  superuserTelemetryImports(
    search: $search
    rowsPerPage: $rowsPerPage
    page: $page
  ) {
    items {
      id
      status
      statusDisplay
      eventDevice {
        id
        event {
          name
        }
        device {
          name
          streamingKey
        }
      }
      createdAt
      createdBy {
        id
        firstName
        lastName
        email
      }
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const SuperuserTelemetryImportDocument = gql`
    query SuperuserTelemetryImport($id: UUID!) {
  superuserTelemetryImportById(id: $id) {
    id
    filename
    s3FileKey
    status
    statusDisplay
    eventDevice {
      id
      event {
        name
      }
    }
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export const SuperuserGenerateTelemetryImportDownloadLinkDocument = gql`
    mutation SuperuserGenerateTelemetryImportDownloadLink($id: UUID!) {
  superuserGenerateTelemetryImportDownloadLink(id: $id) {
    ok
    presignedUrl
  }
}
    `;
export const SuperuserDeleteTelemetryImportDocument = gql`
    mutation SuperuserDeleteTelemetryImport($id: UUID!) {
  superuserDeleteTelemetryImport(id: $id) {
    ok
  }
}
    `;
export const SuperuserRetryTelemetryImportDocument = gql`
    mutation SuperuserRetryTelemetryImport($id: UUID!) {
  superuserRetryTelemetryImport(id: $id) {
    ok
  }
}
    `;
export const LapsDocument = gql`
    query Laps($eventDeviceId: UUID!) {
  laps(eventDeviceId: $eventDeviceId) {
    id
    lapNumber
    lapTime
    endTime
    aggregates
  }
}
    `;
export const LapDataDocument = gql`
    query LapData($lapId: UUID!) {
  lapById(id: $lapId) {
    lapData
  }
}
    `;
export const SuperuserLapsDocument = gql`
    query SuperuserLaps($eventDeviceId: UUID!) {
  superuserLaps(eventDeviceId: $eventDeviceId) {
    id
    endTime
    lapTime
  }
}
    `;
export const SuperuserLapDocument = gql`
    query SuperuserLap($id: UUID!) {
  superuserLap(id: $id) {
    id
    startTime
    endTime
    lapTime
    aggregates
    venue {
      id
      name
    }
  }
}
    `;
export const SuperuserSummaryDocument = gql`
    query SuperuserSummary {
  superuserSummary {
    usersCount
    devicesCount
    eventsCount
    lapsCount
  }
}
    `;
export const PresetTypesDocument = gql`
    query PresetTypes {
  presetTypes {
    id
    prettyName
    description
    typeKey
  }
}
    `;
export const SuperuserPresetTypesDocument = gql`
    query SuperuserPresetTypes {
  superuserPresetTypes {
    id
    prettyName
    description
    typeKey
  }
}
    `;
export const SuperuserPresetTypeDocument = gql`
    query SuperuserPresetType($id: UUID!) {
  superuserPresetTypeById(id: $id) {
    id
    prettyName
    description
    typeKey
  }
}
    `;
export const SuperuserDeletePresetTypeDocument = gql`
    mutation SuperuserDeletePresetType($id: UUID!) {
  superuserDeletePresetType(id: $id) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const SuperuserCreatePresetTypeDocument = gql`
    mutation SuperuserCreatePresetType($prettyName: String!, $description: String!, $typeKey: String!) {
  superuserCreatePresetType(
    prettyName: $prettyName
    description: $description
    typeKey: $typeKey
  ) {
    ok
    errors {
      field
      message
    }
    presetType {
      id
    }
  }
}
    `;
export const SuperuserUpdatePresetTypeDocument = gql`
    mutation SuperuserUpdatePresetType($id: UUID!, $prettyName: String, $description: String, $typeKey: String) {
  superuserUpdatePresetType(
    id: $id
    prettyName: $prettyName
    description: $description
    typeKey: $typeKey
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const PresetsDocument = gql`
    query Presets {
  presets {
    id
    name
    presetType {
      id
      prettyName
    }
  }
}
    `;
export const PresetDocument = gql`
    query Preset($id: UUID!) {
  presetById(id: $id) {
    id
    name
    notes
    createdAt
    presetData
    previewImageSmall
    previewImageMedium
    previewImageLarge
    presetType {
      id
      prettyName
    }
  }
}
    `;
export const CreatePresetDocument = gql`
    mutation CreatePreset($name: String!, $notes: String!, $presetData: String!, $previewImage: Upload, $presetTypeId: UUID!) {
  createPreset(
    name: $name
    notes: $notes
    presetData: $presetData
    previewImage: $previewImage
    presetTypeId: $presetTypeId
  ) {
    ok
    errors {
      field
      message
    }
    preset {
      id
    }
  }
}
    `;
export const EditPresetDocument = gql`
    mutation EditPreset($id: UUID!, $name: String, $notes: String, $presetData: String, $previewImage: Upload, $presetTypeId: UUID) {
  updatePreset(
    id: $id
    name: $name
    notes: $notes
    presetData: $presetData
    previewImage: $previewImage
    presetTypeId: $presetTypeId
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const DeletePresetDocument = gql`
    mutation DeletePreset($id: UUID!) {
  deletePreset(id: $id) {
    ok
  }
}
    `;
export const SuperuserPresetsDocument = gql`
    query SuperuserPresets($rowsPerPage: Int, $page: Int, $isSystem: Boolean) {
  superuserPresets(rowsPerPage: $rowsPerPage, page: $page, isSystem: $isSystem) {
    items {
      id
      name
      isSystem
      presetType {
        id
        prettyName
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;
export const SuperuserPresetDocument = gql`
    query SuperuserPreset($id: UUID!) {
  superuserPresetById(id: $id) {
    id
    name
    notes
    createdAt
    presetData
    previewImageSmall
    previewImageMedium
    previewImageLarge
    presetType {
      id
      prettyName
    }
  }
}
    `;
export const SuperuserCreatePresetDocument = gql`
    mutation SuperuserCreatePreset($name: String!, $notes: String!, $presetData: String!, $previewImage: Upload, $presetTypeId: UUID!) {
  superuserCreatePreset(
    name: $name
    notes: $notes
    presetData: $presetData
    previewImage: $previewImage
    presetTypeId: $presetTypeId
  ) {
    ok
    errors {
      field
      message
    }
    preset {
      id
    }
  }
}
    `;
export const SuperuserEditPresetDocument = gql`
    mutation SuperuserEditPreset($id: UUID!, $name: String, $notes: String, $presetData: String, $previewImage: Upload, $presetTypeId: UUID) {
  superuserUpdatePreset(
    id: $id
    name: $name
    notes: $notes
    presetData: $presetData
    previewImage: $previewImage
    presetTypeId: $presetTypeId
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const SuperuserDeletePresetDocument = gql`
    mutation SuperuserDeletePreset($id: UUID!) {
  superuserDeletePreset(id: $id) {
    ok
  }
}
    `;
export const SubscriptionPlansDocument = gql`
    query SubscriptionPlans {
  subscriptionPlans {
    id
    name
    prettyName
    notes
    priceMonth
    priceYear
    features {
      code
    }
  }
}
    `;
export const FeaturesDocument = gql`
    query Features {
  features {
    code
    description
  }
}
    `;
export const AccountSubscriptionDocument = gql`
    query AccountSubscription {
  accountSubscription {
    isManuallySet
    stripeRenewalFailed
    stripeCurrentPeriodEnd
    subscriptionPlan {
      id
      name
      features {
        code
      }
    }
  }
}
    `;
export const SubscriptionManagmentSessionUrlDocument = gql`
    mutation SubscriptionManagmentSessionUrl($subscriptionPlanId: UUID!, $isMonthly: Boolean) {
  subscriptionManagmentSessionUrl(
    subscriptionPlanId: $subscriptionPlanId
    isMonthly: $isMonthly
  ) {
    ok
    stripeSessionUrl
  }
}
    `;
export const SuperuserUpdateAccountSubscriptionDocument = gql`
    mutation SuperuserUpdateAccountSubscription($accountId: UUID!, $subscriptionPlanId: UUID!) {
  superuserUpdateAccountSubscription(
    accountId: $accountId
    subscriptionPlanId: $subscriptionPlanId
  ) {
    ok
    errors {
      field
      message
    }
    accountSubscription {
      id
      isManuallySet
      stripeCurrentPeriodEnd
      subscriptionPlan {
        id
        name
        prettyName
      }
    }
  }
}
    `;
export const NavbarMeDocument = gql`
    query NavbarMe {
  userMe {
    id
    firstName
  }
}
    `;
export const MeDocument = gql`
    query Me {
  userMe {
    id
    firstName
    lastName
    email
    isActive
  }
}
    `;
export const MyProfileMeDocument = gql`
    query MyProfileMe {
  userMe {
    id
    email
    slug
    firstName
    lastName
    bio
    links
    avatarSmall
    avatarMedium
    avatarLarge
    profilePictureSmall
    profilePictureMedium
    profilePictureLarge
  }
}
    `;
export const SignUpDocument = gql`
    mutation SignUp($accountName: String!, $firstName: String!, $lastName: String!, $email: String!, $password1: String!, $password2: String!, $turnstileToken: String) {
  registerWithAccount(
    accountName: $accountName
    firstName: $firstName
    lastName: $lastName
    email: $email
    password1: $password1
    password2: $password2
    turnstileToken: $turnstileToken
  ) {
    success
    errors
  }
}
    `;
export const UpdateUserMeDocument = gql`
    mutation UpdateUserMe($firstName: String, $lastName: String, $bio: String, $links: [String!], $password: String, $avatar: Upload, $profilePicture: Upload) {
  updateUserMe(
    firstName: $firstName
    lastName: $lastName
    bio: $bio
    links: $links
    password: $password
    avatar: $avatar
    profilePicture: $profilePicture
  ) {
    user {
      id
      email
      slug
      firstName
      lastName
      bio
      links
      avatarSmall
      avatarMedium
      avatarLarge
      profilePictureSmall
      profilePictureMedium
      profilePictureLarge
    }
  }
}
    `;
export const UserListDocument = gql`
    query UserList($search: String, $accountId: UUID, $orderBy: String, $rowsPerPage: Int, $page: Int) {
  superuserUsers(
    email: $search
    accountId: $accountId
    orderBy: $orderBy
    rowsPerPage: $rowsPerPage
    page: $page
  ) {
    items {
      id
      firstName
      lastName
      email
      lastLogin
      createdAt
      isSuperuser
      isActive
      account {
        subscriptionPlan {
          prettyName
        }
      }
    }
    metadata {
      totalCount
    }
  }
}
    `;
export const UserDocument = gql`
    query User($id: UUID!) {
  superuserUserById(id: $id) {
    id
    email
    lastLogin
    createdAt
    firstName
    lastName
    links
    isActive
    isSuperuser
    account {
      id
      name
      subscriptionPlan {
        id
        name
        prettyName
      }
    }
    devices {
      id
      name
      createdAt
    }
  }
}
    `;
export const UserProfileDocument = gql`
    query UserProfile($slug: String!) {
  userBySlug(slug: $slug) {
    id
    slug
    firstName
    lastName
    bio
    links
    followersCount
    followingCount
    isFollowing
    followsViewer
    isViewer
    createdAt
    avatarSmall
    avatarMedium
    avatarLarge
    profilePictureSmall
    profilePictureMedium
    profilePictureLarge
  }
}
    `;
export const PublicUserFollowersDocument = gql`
    query PublicUserFollowers($slug: String!, $rowsPerPage: Int, $page: Int) {
  publicUserFollowers(slug: $slug, rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      slug
      firstName
      lastName
      bio
      followersCount
      followingCount
      isFollowing
      followsViewer
      isViewer
      avatarSmall
      avatarMedium
      avatarLarge
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const PublicUserFollowingDocument = gql`
    query PublicUserFollowing($slug: String!, $rowsPerPage: Int, $page: Int) {
  publicUserFollowing(slug: $slug, rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      slug
      firstName
      lastName
      bio
      followersCount
      followingCount
      isFollowing
      followsViewer
      isViewer
      avatarSmall
      avatarMedium
      avatarLarge
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const FollowUserDocument = gql`
    mutation FollowUser($slug: String!) {
  followUser(slug: $slug) {
    ok
  }
}
    `;
export const UnfollowUserDocument = gql`
    mutation UnfollowUser($slug: String!) {
  unfollowUser(slug: $slug) {
    ok
  }
}
    `;
export const SendPasswordResetEmailDocument = gql`
    mutation SendPasswordResetEmail($email: String!) {
  sendPasswordResetEmail(email: $email) {
    success
    errors
  }
}
    `;
export const ElevateUserDocument = gql`
    mutation ElevateUser($id: UUID!) {
  superuserElevateUser(id: $id) {
    ok
  }
}
    `;
export const DowngradeUserDocument = gql`
    mutation DowngradeUser($id: UUID!) {
  superuserDowngradeUser(id: $id) {
    ok
  }
}
    `;
export const DeactivateUserDocument = gql`
    mutation DeactivateUser($id: UUID!) {
  superuserDeactivateUser(id: $id) {
    ok
  }
}
    `;
export const ReactivateUserDocument = gql`
    mutation ReactivateUser($id: UUID!) {
  superuserReactivateUser(id: $id) {
    ok
  }
}
    `;
export const CreateUserDocument = gql`
    mutation CreateUser($firstName: String!, $lastName: String!, $email: String!, $password1: String!, $password2: String!, $turnstileToken: String) {
  superuserCreateUser(
    firstName: $firstName
    lastName: $lastName
    email: $email
    password1: $password1
    password2: $password2
    turnstileToken: $turnstileToken
  ) {
    ok
    user {
      id
      email
      lastLogin
    }
    errors {
      field
      message
    }
  }
}
    `;
export const SuperuserUpdateUserDocument = gql`
    mutation SuperuserUpdateUser($id: UUID!, $firstName: String!, $lastName: String!, $email: String!, $links: [String!]) {
  superuserUpdateUser(
    id: $id
    firstName: $firstName
    lastName: $lastName
    email: $email
    links: $links
  ) {
    ok
    user {
      id
      email
      firstName
      lastName
      links
    }
    errors {
      field
      message
    }
  }
}
    `;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: UUID!) {
  superuserDeleteUser(id: $id) {
    ok
  }
}
    `;
export const VenuesDocument = gql`
    query Venues($name: String, $region: [LocationInputType!], $rowsPerPage: Int, $page: Int) {
  venues(name: $name, region: $region, rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      name
      configuration
      location
      country
      countryName
      length
      trackMapThumbnail
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const VenuesByNameDocument = gql`
    query VenuesByName($name: String!) {
  venuesByName(name: $name) {
    id
    name
  }
}
    `;
export const MyVenuesDocument = gql`
    query MyVenues($rowsPerPage: Int, $page: Int) {
  myVenues(rowsPerPage: $rowsPerPage, page: $page) {
    items {
      id
      name
      country
      countryName
      length
      trackMapThumbnail
    }
    metadata {
      totalCount
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const VenueDocument = gql`
    query Venue($id: UUID!) {
  venueById(id: $id) {
    id
    name
    location
    country
    countryName
    startFinish
    finish
    length
    trackMapThumbnail
    trackMap
    sectorPoints
    configuration
    minLapTime
    primarySectorScheme
    geometryVersion
    geometryAlgorithm
    geometryGeneratedAt
    geometryStale
    sectorSchemes {
      ...SectorSchemeFields
    }
  }
}
    ${SectorSchemeFieldsFragmentDoc}`;
export const CreateVenueDocument = gql`
    mutation CreateVenue($name: String!, $location: String!, $country: String, $startFinish: String, $finish: String, $length: Float, $trackMap: String, $sectorPoints: String, $configuration: String) {
  createVenue(
    name: $name
    location: $location
    country: $country
    startFinish: $startFinish
    finish: $finish
    length: $length
    trackMap: $trackMap
    sectorPoints: $sectorPoints
    configuration: $configuration
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const EditVenueDocument = gql`
    mutation EditVenue($id: UUID!, $name: String!, $location: String!, $country: String, $startFinish: String, $finish: String, $length: Float, $trackMap: String, $sectorPoints: String, $configuration: String) {
  updateVenue(
    id: $id
    name: $name
    location: $location
    country: $country
    startFinish: $startFinish
    finish: $finish
    length: $length
    trackMap: $trackMap
    sectorPoints: $sectorPoints
    configuration: $configuration
  ) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const DeleteVenueDocument = gql`
    mutation DeleteVenue($id: UUID!) {
  deleteVenue(id: $id) {
    ok
  }
}
    `;
export const VenueGeometryStatusDocument = gql`
    query VenueGeometryStatus {
  superuserVenueGeometryStatus {
    totalWithTrackMap
    stale
  }
}
    `;
export const UpdateVenueSectorSchemeDocument = gql`
    mutation UpdateVenueSectorScheme($venueId: UUID!, $key: String!, $points: [SectorPointInput!]!, $label: String) {
  updateVenueSectorScheme(
    venueId: $venueId
    key: $key
    points: $points
    label: $label
  ) {
    ok
    errors {
      field
      message
    }
    scheme {
      ...SectorSchemeFields
    }
  }
}
    ${SectorSchemeFieldsFragmentDoc}`;
export const RegenerateVenueSectorSchemeDocument = gql`
    mutation RegenerateVenueSectorScheme($venueId: UUID!, $key: String!) {
  regenerateVenueSectorScheme(venueId: $venueId, key: $key) {
    ok
    errors {
      field
      message
    }
    scheme {
      ...SectorSchemeFields
    }
  }
}
    ${SectorSchemeFieldsFragmentDoc}`;
export const SetPrimarySectorSchemeDocument = gql`
    mutation SetPrimarySectorScheme($venueId: UUID!, $key: String!) {
  setPrimarySectorScheme(venueId: $venueId, key: $key) {
    ok
    errors {
      field
      message
    }
    scheme {
      key
    }
  }
}
    `;
export const CreateVenueSectorSchemeDocument = gql`
    mutation CreateVenueSectorScheme($venueId: UUID!, $key: String!, $label: String!, $copyFrom: String) {
  createVenueSectorScheme(
    venueId: $venueId
    key: $key
    label: $label
    copyFrom: $copyFrom
  ) {
    ok
    errors {
      field
      message
    }
    scheme {
      ...SectorSchemeFields
    }
  }
}
    ${SectorSchemeFieldsFragmentDoc}`;
export const DeleteVenueSectorSchemeDocument = gql`
    mutation DeleteVenueSectorScheme($venueId: UUID!, $key: String!) {
  deleteVenueSectorScheme(venueId: $venueId, key: $key) {
    ok
    errors {
      field
      message
    }
  }
}
    `;
export const SuperuserRegenerateVenueGeometryDocument = gql`
    mutation SuperuserRegenerateVenueGeometry($limit: Int!, $force: Boolean!) {
  superuserRegenerateVenueGeometry(limit: $limit, force: $force) {
    processed
    remaining
    results {
      venueId
      name
      status
      message
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    MyAccount(variables?: MyAccountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyAccountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyAccountQuery>({ document: MyAccountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MyAccount', 'query', variables);
    },
    UpdateAccount(variables?: UpdateAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAccountMutation>({ document: UpdateAccountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateAccount', 'mutation', variables);
    },
    ResendActivationEmail(variables: ResendActivationEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ResendActivationEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResendActivationEmailMutation>({ document: ResendActivationEmailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ResendActivationEmail', 'mutation', variables);
    },
    Account(variables: AccountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AccountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountQuery>({ document: AccountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Account', 'query', variables);
    },
    AlertMessages(variables: AlertMessagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AlertMessagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AlertMessagesQuery>({ document: AlertMessagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AlertMessages', 'query', variables);
    },
    MyDevices(variables?: MyDevicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyDevicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyDevicesQuery>({ document: MyDevicesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MyDevices', 'query', variables);
    },
    Device(variables: DeviceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeviceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeviceQuery>({ document: DeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Device', 'query', variables);
    },
    CreateDevice(variables: CreateDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDeviceMutation>({ document: CreateDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateDevice', 'mutation', variables);
    },
    DeleteDevice(variables: DeleteDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDeviceMutation>({ document: DeleteDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteDevice', 'mutation', variables);
    },
    EditDevice(variables: EditDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditDeviceMutation>({ document: EditDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EditDevice', 'mutation', variables);
    },
    SuperuserDevices(variables?: SuperuserDevicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserDevicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserDevicesQuery>({ document: SuperuserDevicesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserDevices', 'query', variables);
    },
    SuperuserDevice(variables: SuperuserDeviceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserDeviceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserDeviceQuery>({ document: SuperuserDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserDevice', 'query', variables);
    },
    EventDevices(variables: EventDevicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EventDevicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EventDevicesQuery>({ document: EventDevicesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EventDevices', 'query', variables);
    },
    EventDevice(variables: EventDeviceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EventDeviceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EventDeviceQuery>({ document: EventDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EventDevice', 'query', variables);
    },
    SuperuserDeviceEvents(variables?: SuperuserDeviceEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserDeviceEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserDeviceEventsQuery>({ document: SuperuserDeviceEventsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserDeviceEvents', 'query', variables);
    },
    SuperuserEventDevices(variables?: SuperuserEventDevicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserEventDevicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserEventDevicesQuery>({ document: SuperuserEventDevicesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserEventDevices', 'query', variables);
    },
    SuperuserEventDevice(variables: SuperuserEventDeviceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserEventDeviceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserEventDeviceQuery>({ document: SuperuserEventDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserEventDevice', 'query', variables);
    },
    SuperuserLiveStreams(variables?: SuperuserLiveStreamsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserLiveStreamsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserLiveStreamsQuery>({ document: SuperuserLiveStreamsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserLiveStreams', 'query', variables);
    },
    SuperuserDeleteEventDevice(variables: SuperuserDeleteEventDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserDeleteEventDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserDeleteEventDeviceMutation>({ document: SuperuserDeleteEventDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserDeleteEventDevice', 'mutation', variables);
    },
    CreateEventDevice(variables: CreateEventDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateEventDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEventDeviceMutation>({ document: CreateEventDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateEventDevice', 'mutation', variables);
    },
    UpdateEventDevice(variables: UpdateEventDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateEventDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateEventDeviceMutation>({ document: UpdateEventDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateEventDevice', 'mutation', variables);
    },
    DeleteEventDevice(variables: DeleteEventDeviceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteEventDeviceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteEventDeviceMutation>({ document: DeleteEventDeviceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteEventDevice', 'mutation', variables);
    },
    SuperuserEventDeviceDataSegments(variables: SuperuserEventDeviceDataSegmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserEventDeviceDataSegmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserEventDeviceDataSegmentsQuery>({ document: SuperuserEventDeviceDataSegmentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserEventDeviceDataSegments', 'query', variables);
    },
    SuperuserGetEventDeviceDataSegmentDownloadLink(variables: SuperuserGetEventDeviceDataSegmentDownloadLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserGetEventDeviceDataSegmentDownloadLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserGetEventDeviceDataSegmentDownloadLinkMutation>({ document: SuperuserGetEventDeviceDataSegmentDownloadLinkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserGetEventDeviceDataSegmentDownloadLink', 'mutation', variables);
    },
    Events(variables?: EventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EventsQuery>({ document: EventsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Events', 'query', variables);
    },
    MyEvents(variables?: MyEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyEventsQuery>({ document: MyEventsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MyEvents', 'query', variables);
    },
    PublicUserEvents(variables: PublicUserEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublicUserEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublicUserEventsQuery>({ document: PublicUserEventsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PublicUserEvents', 'query', variables);
    },
    Event(variables: EventQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EventQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EventQuery>({ document: EventDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Event', 'query', variables);
    },
    EventDeviceLapSummaries(variables: EventDeviceLapSummariesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EventDeviceLapSummariesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EventDeviceLapSummariesQuery>({ document: EventDeviceLapSummariesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EventDeviceLapSummaries', 'query', variables);
    },
    CreateEvent(variables: CreateEventMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateEventMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEventMutation>({ document: CreateEventDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateEvent', 'mutation', variables);
    },
    EditEvent(variables: EditEventMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditEventMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditEventMutation>({ document: EditEventDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EditEvent', 'mutation', variables);
    },
    DeleteEvent(variables: DeleteEventMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteEventMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteEventMutation>({ document: DeleteEventDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteEvent', 'mutation', variables);
    },
    SuperuserEvents(variables?: SuperuserEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserEventsQuery>({ document: SuperuserEventsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserEvents', 'query', variables);
    },
    SuperuserEvent(variables: SuperuserEventQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserEventQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserEventQuery>({ document: SuperuserEventDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserEvent', 'query', variables);
    },
    SuperuserDeleteEvent(variables: SuperuserDeleteEventMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserDeleteEventMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserDeleteEventMutation>({ document: SuperuserDeleteEventDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserDeleteEvent', 'mutation', variables);
    },
    CreateTelemetryExport(variables: CreateTelemetryExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateTelemetryExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTelemetryExportMutation>({ document: CreateTelemetryExportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateTelemetryExport', 'mutation', variables);
    },
    TelemetryExports(variables?: TelemetryExportsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TelemetryExportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TelemetryExportsQuery>({ document: TelemetryExportsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TelemetryExports', 'query', variables);
    },
    GenerateTelemetryExportFileDownloadLink(variables: GenerateTelemetryExportFileDownloadLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GenerateTelemetryExportFileDownloadLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateTelemetryExportFileDownloadLinkMutation>({ document: GenerateTelemetryExportFileDownloadLinkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GenerateTelemetryExportFileDownloadLink', 'mutation', variables);
    },
    DeleteTelemetryExport(variables: DeleteTelemetryExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteTelemetryExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTelemetryExportMutation>({ document: DeleteTelemetryExportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteTelemetryExport', 'mutation', variables);
    },
    SuperuserTelemetryExports(variables?: SuperuserTelemetryExportsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserTelemetryExportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserTelemetryExportsQuery>({ document: SuperuserTelemetryExportsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserTelemetryExports', 'query', variables);
    },
    SuperuserGenerateTelemetryExportDownloadLink(variables: SuperuserGenerateTelemetryExportDownloadLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserGenerateTelemetryExportDownloadLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserGenerateTelemetryExportDownloadLinkMutation>({ document: SuperuserGenerateTelemetryExportDownloadLinkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserGenerateTelemetryExportDownloadLink', 'mutation', variables);
    },
    SuperuserDeleteTelemetryExport(variables: SuperuserDeleteTelemetryExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserDeleteTelemetryExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserDeleteTelemetryExportMutation>({ document: SuperuserDeleteTelemetryExportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserDeleteTelemetryExport', 'mutation', variables);
    },
    Feed(variables?: FeedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FeedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FeedQuery>({ document: FeedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Feed', 'query', variables);
    },
    CreateTelemetryImport(variables: CreateTelemetryImportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateTelemetryImportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTelemetryImportMutation>({ document: CreateTelemetryImportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateTelemetryImport', 'mutation', variables);
    },
    TelemetryImports(variables?: TelemetryImportsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TelemetryImportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TelemetryImportsQuery>({ document: TelemetryImportsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TelemetryImports', 'query', variables);
    },
    TelemetryImport(variables: TelemetryImportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TelemetryImportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TelemetryImportQuery>({ document: TelemetryImportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TelemetryImport', 'query', variables);
    },
    GenerateSourceFileDownloadLink(variables: GenerateSourceFileDownloadLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GenerateSourceFileDownloadLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateSourceFileDownloadLinkMutation>({ document: GenerateSourceFileDownloadLinkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GenerateSourceFileDownloadLink', 'mutation', variables);
    },
    DeleteTelemetryImport(variables: DeleteTelemetryImportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteTelemetryImportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTelemetryImportMutation>({ document: DeleteTelemetryImportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteTelemetryImport', 'mutation', variables);
    },
    SuperuserTelemetryImports(variables?: SuperuserTelemetryImportsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserTelemetryImportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserTelemetryImportsQuery>({ document: SuperuserTelemetryImportsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserTelemetryImports', 'query', variables);
    },
    SuperuserTelemetryImport(variables: SuperuserTelemetryImportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserTelemetryImportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserTelemetryImportQuery>({ document: SuperuserTelemetryImportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserTelemetryImport', 'query', variables);
    },
    SuperuserGenerateTelemetryImportDownloadLink(variables: SuperuserGenerateTelemetryImportDownloadLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserGenerateTelemetryImportDownloadLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserGenerateTelemetryImportDownloadLinkMutation>({ document: SuperuserGenerateTelemetryImportDownloadLinkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserGenerateTelemetryImportDownloadLink', 'mutation', variables);
    },
    SuperuserDeleteTelemetryImport(variables: SuperuserDeleteTelemetryImportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserDeleteTelemetryImportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserDeleteTelemetryImportMutation>({ document: SuperuserDeleteTelemetryImportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserDeleteTelemetryImport', 'mutation', variables);
    },
    SuperuserRetryTelemetryImport(variables: SuperuserRetryTelemetryImportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserRetryTelemetryImportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserRetryTelemetryImportMutation>({ document: SuperuserRetryTelemetryImportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserRetryTelemetryImport', 'mutation', variables);
    },
    Laps(variables: LapsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LapsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LapsQuery>({ document: LapsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Laps', 'query', variables);
    },
    LapData(variables: LapDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LapDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LapDataQuery>({ document: LapDataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'LapData', 'query', variables);
    },
    SuperuserLaps(variables: SuperuserLapsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserLapsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserLapsQuery>({ document: SuperuserLapsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserLaps', 'query', variables);
    },
    SuperuserLap(variables: SuperuserLapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserLapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserLapQuery>({ document: SuperuserLapDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserLap', 'query', variables);
    },
    SuperuserSummary(variables?: SuperuserSummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserSummaryQuery>({ document: SuperuserSummaryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserSummary', 'query', variables);
    },
    PresetTypes(variables?: PresetTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PresetTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PresetTypesQuery>({ document: PresetTypesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PresetTypes', 'query', variables);
    },
    SuperuserPresetTypes(variables?: SuperuserPresetTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserPresetTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserPresetTypesQuery>({ document: SuperuserPresetTypesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserPresetTypes', 'query', variables);
    },
    SuperuserPresetType(variables: SuperuserPresetTypeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserPresetTypeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserPresetTypeQuery>({ document: SuperuserPresetTypeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserPresetType', 'query', variables);
    },
    SuperuserDeletePresetType(variables: SuperuserDeletePresetTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserDeletePresetTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserDeletePresetTypeMutation>({ document: SuperuserDeletePresetTypeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserDeletePresetType', 'mutation', variables);
    },
    SuperuserCreatePresetType(variables: SuperuserCreatePresetTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserCreatePresetTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserCreatePresetTypeMutation>({ document: SuperuserCreatePresetTypeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserCreatePresetType', 'mutation', variables);
    },
    SuperuserUpdatePresetType(variables: SuperuserUpdatePresetTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserUpdatePresetTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserUpdatePresetTypeMutation>({ document: SuperuserUpdatePresetTypeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserUpdatePresetType', 'mutation', variables);
    },
    Presets(variables?: PresetsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PresetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PresetsQuery>({ document: PresetsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Presets', 'query', variables);
    },
    Preset(variables: PresetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PresetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PresetQuery>({ document: PresetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Preset', 'query', variables);
    },
    CreatePreset(variables: CreatePresetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreatePresetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePresetMutation>({ document: CreatePresetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreatePreset', 'mutation', variables);
    },
    EditPreset(variables: EditPresetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditPresetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditPresetMutation>({ document: EditPresetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EditPreset', 'mutation', variables);
    },
    DeletePreset(variables: DeletePresetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeletePresetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePresetMutation>({ document: DeletePresetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeletePreset', 'mutation', variables);
    },
    SuperuserPresets(variables?: SuperuserPresetsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserPresetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserPresetsQuery>({ document: SuperuserPresetsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserPresets', 'query', variables);
    },
    SuperuserPreset(variables: SuperuserPresetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserPresetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserPresetQuery>({ document: SuperuserPresetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserPreset', 'query', variables);
    },
    SuperuserCreatePreset(variables: SuperuserCreatePresetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserCreatePresetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserCreatePresetMutation>({ document: SuperuserCreatePresetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserCreatePreset', 'mutation', variables);
    },
    SuperuserEditPreset(variables: SuperuserEditPresetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserEditPresetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserEditPresetMutation>({ document: SuperuserEditPresetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserEditPreset', 'mutation', variables);
    },
    SuperuserDeletePreset(variables: SuperuserDeletePresetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserDeletePresetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserDeletePresetMutation>({ document: SuperuserDeletePresetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserDeletePreset', 'mutation', variables);
    },
    SubscriptionPlans(variables?: SubscriptionPlansQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SubscriptionPlansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubscriptionPlansQuery>({ document: SubscriptionPlansDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SubscriptionPlans', 'query', variables);
    },
    Features(variables?: FeaturesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FeaturesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FeaturesQuery>({ document: FeaturesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Features', 'query', variables);
    },
    AccountSubscription(variables?: AccountSubscriptionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AccountSubscriptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountSubscriptionQuery>({ document: AccountSubscriptionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AccountSubscription', 'query', variables);
    },
    SubscriptionManagmentSessionUrl(variables: SubscriptionManagmentSessionUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SubscriptionManagmentSessionUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubscriptionManagmentSessionUrlMutation>({ document: SubscriptionManagmentSessionUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SubscriptionManagmentSessionUrl', 'mutation', variables);
    },
    SuperuserUpdateAccountSubscription(variables: SuperuserUpdateAccountSubscriptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserUpdateAccountSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserUpdateAccountSubscriptionMutation>({ document: SuperuserUpdateAccountSubscriptionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserUpdateAccountSubscription', 'mutation', variables);
    },
    NavbarMe(variables?: NavbarMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<NavbarMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NavbarMeQuery>({ document: NavbarMeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'NavbarMe', 'query', variables);
    },
    Me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>({ document: MeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Me', 'query', variables);
    },
    MyProfileMe(variables?: MyProfileMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyProfileMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyProfileMeQuery>({ document: MyProfileMeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MyProfileMe', 'query', variables);
    },
    SignUp(variables: SignUpMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SignUpMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignUpMutation>({ document: SignUpDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SignUp', 'mutation', variables);
    },
    UpdateUserMe(variables?: UpdateUserMeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateUserMeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserMeMutation>({ document: UpdateUserMeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateUserMe', 'mutation', variables);
    },
    UserList(variables?: UserListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserListQuery>({ document: UserListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UserList', 'query', variables);
    },
    User(variables: UserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserQuery>({ document: UserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'User', 'query', variables);
    },
    UserProfile(variables: UserProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserProfileQuery>({ document: UserProfileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UserProfile', 'query', variables);
    },
    PublicUserFollowers(variables: PublicUserFollowersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublicUserFollowersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublicUserFollowersQuery>({ document: PublicUserFollowersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PublicUserFollowers', 'query', variables);
    },
    PublicUserFollowing(variables: PublicUserFollowingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PublicUserFollowingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublicUserFollowingQuery>({ document: PublicUserFollowingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PublicUserFollowing', 'query', variables);
    },
    FollowUser(variables: FollowUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FollowUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FollowUserMutation>({ document: FollowUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'FollowUser', 'mutation', variables);
    },
    UnfollowUser(variables: UnfollowUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UnfollowUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnfollowUserMutation>({ document: UnfollowUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UnfollowUser', 'mutation', variables);
    },
    SendPasswordResetEmail(variables: SendPasswordResetEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SendPasswordResetEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendPasswordResetEmailMutation>({ document: SendPasswordResetEmailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SendPasswordResetEmail', 'mutation', variables);
    },
    ElevateUser(variables: ElevateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ElevateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ElevateUserMutation>({ document: ElevateUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ElevateUser', 'mutation', variables);
    },
    DowngradeUser(variables: DowngradeUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DowngradeUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DowngradeUserMutation>({ document: DowngradeUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DowngradeUser', 'mutation', variables);
    },
    DeactivateUser(variables: DeactivateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeactivateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeactivateUserMutation>({ document: DeactivateUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeactivateUser', 'mutation', variables);
    },
    ReactivateUser(variables: ReactivateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ReactivateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReactivateUserMutation>({ document: ReactivateUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ReactivateUser', 'mutation', variables);
    },
    CreateUser(variables: CreateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserMutation>({ document: CreateUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateUser', 'mutation', variables);
    },
    SuperuserUpdateUser(variables: SuperuserUpdateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserUpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserUpdateUserMutation>({ document: SuperuserUpdateUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserUpdateUser', 'mutation', variables);
    },
    DeleteUser(variables: DeleteUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUserMutation>({ document: DeleteUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteUser', 'mutation', variables);
    },
    Venues(variables?: VenuesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VenuesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenuesQuery>({ document: VenuesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Venues', 'query', variables);
    },
    VenuesByName(variables: VenuesByNameQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VenuesByNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenuesByNameQuery>({ document: VenuesByNameDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VenuesByName', 'query', variables);
    },
    MyVenues(variables?: MyVenuesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MyVenuesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyVenuesQuery>({ document: MyVenuesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MyVenues', 'query', variables);
    },
    Venue(variables: VenueQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VenueQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueQuery>({ document: VenueDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Venue', 'query', variables);
    },
    CreateVenue(variables: CreateVenueMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateVenueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVenueMutation>({ document: CreateVenueDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateVenue', 'mutation', variables);
    },
    EditVenue(variables: EditVenueMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EditVenueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditVenueMutation>({ document: EditVenueDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EditVenue', 'mutation', variables);
    },
    DeleteVenue(variables: DeleteVenueMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteVenueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVenueMutation>({ document: DeleteVenueDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteVenue', 'mutation', variables);
    },
    VenueGeometryStatus(variables?: VenueGeometryStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VenueGeometryStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VenueGeometryStatusQuery>({ document: VenueGeometryStatusDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VenueGeometryStatus', 'query', variables);
    },
    UpdateVenueSectorScheme(variables: UpdateVenueSectorSchemeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateVenueSectorSchemeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVenueSectorSchemeMutation>({ document: UpdateVenueSectorSchemeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateVenueSectorScheme', 'mutation', variables);
    },
    RegenerateVenueSectorScheme(variables: RegenerateVenueSectorSchemeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RegenerateVenueSectorSchemeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegenerateVenueSectorSchemeMutation>({ document: RegenerateVenueSectorSchemeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RegenerateVenueSectorScheme', 'mutation', variables);
    },
    SetPrimarySectorScheme(variables: SetPrimarySectorSchemeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SetPrimarySectorSchemeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetPrimarySectorSchemeMutation>({ document: SetPrimarySectorSchemeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SetPrimarySectorScheme', 'mutation', variables);
    },
    CreateVenueSectorScheme(variables: CreateVenueSectorSchemeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateVenueSectorSchemeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVenueSectorSchemeMutation>({ document: CreateVenueSectorSchemeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateVenueSectorScheme', 'mutation', variables);
    },
    DeleteVenueSectorScheme(variables: DeleteVenueSectorSchemeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteVenueSectorSchemeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteVenueSectorSchemeMutation>({ document: DeleteVenueSectorSchemeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteVenueSectorScheme', 'mutation', variables);
    },
    SuperuserRegenerateVenueGeometry(variables: SuperuserRegenerateVenueGeometryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SuperuserRegenerateVenueGeometryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SuperuserRegenerateVenueGeometryMutation>({ document: SuperuserRegenerateVenueGeometryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SuperuserRegenerateVenueGeometry', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;